export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AboutUsAboutDynamicDynamicZoneInput: any;
  BlogBlogDynamicDynamicZoneInput: any;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  HomePageHomeDynamicDynamicZoneInput: any;
  /** A string used to identify an i18n locale */
  I18NLocaleCode: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  Long: any;
  PagePageDynamicDynamicZoneInput: any;
  ProjectProjectsDynamicDynamicZoneInput: any;
  ServiceServiceDynamicDynamicZoneInput: any;
};


export type AboutUs = {
  __typename?: 'AboutUs';
  documentId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  banner?: Maybe<UploadFile>;
  body?: Maybe<Scalars['String']>;
  aboutDynamic?: Maybe<Array<Maybe<AboutUsAboutDynamicDynamicZone>>>;
  metadata?: Maybe<ComponentComponentsMetadata>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations_connection?: Maybe<AboutUsRelationResponseCollection>;
  localizations: Array<Maybe<AboutUs>>;
};

export type AboutUsAboutDynamicDynamicZone = ComponentComponentsUserTestimony | ComponentComponentsDottedList | ComponentComponentsTimeline | ComponentComponentsSection | ComponentComponentsCompanyForm | ComponentComponentsContactForm | ComponentComponentsHubspotMeeting | ComponentComponentsSectionBackgroundImageRichText | ComponentComponentsSectionImageRichText | ComponentComponentsSectionQuote | ComponentComponentsSectionTextButtons | ComponentComponentsSectionTextColumns | ComponentComponentsSectionCards | ComponentComponentsSectionImageRichTextList | ComponentComponentsEventList | Error;


export type AboutUsInput = {
  title?: Maybe<Scalars['String']>;
  banner?: Maybe<Scalars['ID']>;
  body?: Maybe<Scalars['String']>;
  aboutDynamic?: Maybe<Array<Scalars['AboutUsAboutDynamicDynamicZoneInput']>>;
  metadata?: Maybe<ComponentComponentsMetadataInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type AboutUsRelationResponseCollection = {
  __typename?: 'AboutUsRelationResponseCollection';
  nodes: Array<AboutUs>;
};

export type AcademyAboutUs = {
  __typename?: 'AcademyAboutUs';
  documentId: Scalars['ID'];
  metadata?: Maybe<ComponentComponentsMetadata>;
  bannerTitle?: Maybe<Scalars['String']>;
  bannerImg?: Maybe<UploadFile>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<UploadFile>;
  cards?: Maybe<Array<Maybe<ComponentAcademyCards>>>;
  valuesDescription?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type AcademyAboutUsCardsArgs = {
  filters?: Maybe<ComponentAcademyCardsFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AcademyAboutUsInput = {
  metadata?: Maybe<ComponentComponentsMetadataInput>;
  bannerTitle?: Maybe<Scalars['String']>;
  bannerImg?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
  cards?: Maybe<Array<Maybe<ComponentAcademyCardsInput>>>;
  valuesDescription?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type AcademyContact = {
  __typename?: 'AcademyContact';
  documentId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type AcademyContactEntityResponseCollection = {
  __typename?: 'AcademyContactEntityResponseCollection';
  nodes: Array<AcademyContact>;
  pageInfo: Pagination;
};

export type AcademyContactFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  phone?: Maybe<StringFilterInput>;
  email?: Maybe<StringFilterInput>;
  subject?: Maybe<StringFilterInput>;
  message?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<AcademyContactFiltersInput>>>;
  or?: Maybe<Array<Maybe<AcademyContactFiltersInput>>>;
  not?: Maybe<AcademyContactFiltersInput>;
};

export type AcademyContactInput = {
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type Author = {
  __typename?: 'Author';
  documentId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  twitterUrl?: Maybe<Scalars['String']>;
  facebookUrl?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  instagramUrl?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
  image?: Maybe<UploadFile>;
  courses_connection?: Maybe<CourseRelationResponseCollection>;
  courses: Array<Maybe<Course>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations_connection?: Maybe<AuthorRelationResponseCollection>;
  localizations: Array<Maybe<Author>>;
};


export type AuthorCourses_ConnectionArgs = {
  filters?: Maybe<CourseFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type AuthorCoursesArgs = {
  filters?: Maybe<CourseFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type AuthorLocalizations_ConnectionArgs = {
  filters?: Maybe<AuthorFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type AuthorLocalizationsArgs = {
  filters?: Maybe<AuthorFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AuthorEntityResponseCollection = {
  __typename?: 'AuthorEntityResponseCollection';
  nodes: Array<Author>;
  pageInfo: Pagination;
};

export type AuthorFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  body?: Maybe<StringFilterInput>;
  role?: Maybe<StringFilterInput>;
  twitterUrl?: Maybe<StringFilterInput>;
  facebookUrl?: Maybe<StringFilterInput>;
  linkedinUrl?: Maybe<StringFilterInput>;
  instagramUrl?: Maybe<StringFilterInput>;
  youtubeUrl?: Maybe<StringFilterInput>;
  courses?: Maybe<CourseFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  locale?: Maybe<StringFilterInput>;
  localizations?: Maybe<AuthorFiltersInput>;
  and?: Maybe<Array<Maybe<AuthorFiltersInput>>>;
  or?: Maybe<Array<Maybe<AuthorFiltersInput>>>;
  not?: Maybe<AuthorFiltersInput>;
};

export type AuthorInput = {
  name?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  twitterUrl?: Maybe<Scalars['String']>;
  facebookUrl?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  instagramUrl?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
  courses?: Maybe<Array<Maybe<Scalars['ID']>>>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type AuthorRelationResponseCollection = {
  __typename?: 'AuthorRelationResponseCollection';
  nodes: Array<Author>;
};

export type Blog = {
  __typename?: 'Blog';
  documentId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  featuredPost?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  metadata?: Maybe<ComponentComponentsMetadata>;
  blogDynamic?: Maybe<Array<Maybe<BlogBlogDynamicDynamicZone>>>;
  publicationDate: Scalars['Date'];
  featuredImage?: Maybe<UploadFile>;
  author?: Maybe<Author>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations_connection?: Maybe<BlogRelationResponseCollection>;
  localizations: Array<Maybe<Blog>>;
};


export type BlogLocalizations_ConnectionArgs = {
  filters?: Maybe<BlogFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type BlogLocalizationsArgs = {
  filters?: Maybe<BlogFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type BlogBlogDynamicDynamicZone = ComponentComponentsRichtext | ComponentComponentsUserTestimony | ComponentComponentsGallery | ComponentComponentsTestimonialDetail | ComponentComponentsContactForm | ComponentComponentsSectionTextButtons | ComponentComponentsSectionQuote | ComponentComponentsSectionImageRichText | ComponentComponentsSectionBackgroundImageRichText | ComponentComponentsCompanyForm | ComponentComponentsHubspotMeeting | ComponentComponentsSectionCards | ComponentComponentsSectionTextColumns | ComponentComponentsSectionImageRichTextList | ComponentComponentsEventList | Error;


export type BlogEntityResponseCollection = {
  __typename?: 'BlogEntityResponseCollection';
  nodes: Array<Blog>;
  pageInfo: Pagination;
};

export type BlogFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  title?: Maybe<StringFilterInput>;
  description?: Maybe<StringFilterInput>;
  featuredPost?: Maybe<BooleanFilterInput>;
  slug?: Maybe<StringFilterInput>;
  metadata?: Maybe<ComponentComponentsMetadataFiltersInput>;
  publicationDate?: Maybe<DateFilterInput>;
  author?: Maybe<AuthorFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  locale?: Maybe<StringFilterInput>;
  localizations?: Maybe<BlogFiltersInput>;
  and?: Maybe<Array<Maybe<BlogFiltersInput>>>;
  or?: Maybe<Array<Maybe<BlogFiltersInput>>>;
  not?: Maybe<BlogFiltersInput>;
};

export type BlogInput = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  featuredPost?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  metadata?: Maybe<ComponentComponentsMetadataInput>;
  blogDynamic?: Maybe<Array<Scalars['BlogBlogDynamicDynamicZoneInput']>>;
  publicationDate?: Maybe<Scalars['Date']>;
  featuredImage?: Maybe<Scalars['ID']>;
  author?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type BlogRelationResponseCollection = {
  __typename?: 'BlogRelationResponseCollection';
  nodes: Array<Blog>;
};

export type BlogsPage = {
  __typename?: 'BlogsPage';
  documentId: Scalars['ID'];
  metadata?: Maybe<ComponentComponentsMetadata>;
  banner?: Maybe<UploadFile>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations_connection?: Maybe<BlogsPageRelationResponseCollection>;
  localizations: Array<Maybe<BlogsPage>>;
};

export type BlogsPageInput = {
  metadata?: Maybe<ComponentComponentsMetadataInput>;
  banner?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type BlogsPageRelationResponseCollection = {
  __typename?: 'BlogsPageRelationResponseCollection';
  nodes: Array<BlogsPage>;
};

export type BooleanFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  or?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  not?: Maybe<BooleanFilterInput>;
  eq?: Maybe<Scalars['Boolean']>;
  eqi?: Maybe<Scalars['Boolean']>;
  ne?: Maybe<Scalars['Boolean']>;
  nei?: Maybe<Scalars['Boolean']>;
  startsWith?: Maybe<Scalars['Boolean']>;
  endsWith?: Maybe<Scalars['Boolean']>;
  contains?: Maybe<Scalars['Boolean']>;
  notContains?: Maybe<Scalars['Boolean']>;
  containsi?: Maybe<Scalars['Boolean']>;
  notContainsi?: Maybe<Scalars['Boolean']>;
  gt?: Maybe<Scalars['Boolean']>;
  gte?: Maybe<Scalars['Boolean']>;
  lt?: Maybe<Scalars['Boolean']>;
  lte?: Maybe<Scalars['Boolean']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  between?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
};

export type ComponentAcademyCards = {
  __typename?: 'ComponentAcademyCards';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<ComponentAcademyItemsList>>>;
};


export type ComponentAcademyCardsItemsArgs = {
  filters?: Maybe<ComponentAcademyItemsListFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentAcademyCardsFiltersInput = {
  title?: Maybe<StringFilterInput>;
  description?: Maybe<StringFilterInput>;
  items?: Maybe<ComponentAcademyItemsListFiltersInput>;
  and?: Maybe<Array<Maybe<ComponentAcademyCardsFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentAcademyCardsFiltersInput>>>;
  not?: Maybe<ComponentAcademyCardsFiltersInput>;
};

export type ComponentAcademyCardsInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<ComponentAcademyItemsListInput>>>;
};

export type ComponentAcademyCurriculumItem = {
  __typename?: 'ComponentAcademyCurriculumItem';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
};

export type ComponentAcademyCurriculumItemFiltersInput = {
  title?: Maybe<StringFilterInput>;
  duration?: Maybe<StringFilterInput>;
  and?: Maybe<Array<Maybe<ComponentAcademyCurriculumItemFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentAcademyCurriculumItemFiltersInput>>>;
  not?: Maybe<ComponentAcademyCurriculumItemFiltersInput>;
};

export type ComponentAcademyCurriculumItemInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
};

export type ComponentAcademyCurriculumList = {
  __typename?: 'ComponentAcademyCurriculumList';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  curriculumItem?: Maybe<Array<Maybe<ComponentAcademyCurriculumItem>>>;
};


export type ComponentAcademyCurriculumListCurriculumItemArgs = {
  filters?: Maybe<ComponentAcademyCurriculumItemFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentAcademyCurriculumListFiltersInput = {
  title?: Maybe<StringFilterInput>;
  curriculumItem?: Maybe<ComponentAcademyCurriculumItemFiltersInput>;
  and?: Maybe<Array<Maybe<ComponentAcademyCurriculumListFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentAcademyCurriculumListFiltersInput>>>;
  not?: Maybe<ComponentAcademyCurriculumListFiltersInput>;
};

export type ComponentAcademyCurriculumListInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  curriculumItem?: Maybe<Array<Maybe<ComponentAcademyCurriculumItemInput>>>;
};

export type ComponentAcademyItemsList = {
  __typename?: 'ComponentAcademyItemsList';
  id: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
};

export type ComponentAcademyItemsListFiltersInput = {
  description?: Maybe<StringFilterInput>;
  and?: Maybe<Array<Maybe<ComponentAcademyItemsListFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentAcademyItemsListFiltersInput>>>;
  not?: Maybe<ComponentAcademyItemsListFiltersInput>;
};

export type ComponentAcademyItemsListInput = {
  id?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
};

export type ComponentComponentsActionLink = {
  __typename?: 'ComponentComponentsActionLink';
  id: Scalars['ID'];
  title: Scalars['String'];
  destinationUrl: Scalars['String'];
};

export type ComponentComponentsAnswer = {
  __typename?: 'ComponentComponentsAnswer';
  id: Scalars['ID'];
  question?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
  answerOptions?: Maybe<Array<Maybe<ComponentComponentsAnswerOption>>>;
  questionHash?: Maybe<Scalars['String']>;
};


export type ComponentComponentsAnswerAnswerOptionsArgs = {
  filters?: Maybe<ComponentComponentsAnswerOptionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentComponentsAnswerFiltersInput = {
  question?: Maybe<StringFilterInput>;
  answer?: Maybe<StringFilterInput>;
  answerOptions?: Maybe<ComponentComponentsAnswerOptionFiltersInput>;
  questionHash?: Maybe<StringFilterInput>;
  and?: Maybe<Array<Maybe<ComponentComponentsAnswerFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentComponentsAnswerFiltersInput>>>;
  not?: Maybe<ComponentComponentsAnswerFiltersInput>;
};

export type ComponentComponentsAnswerInput = {
  id?: Maybe<Scalars['ID']>;
  question?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
  answerOptions?: Maybe<Array<Maybe<ComponentComponentsAnswerOptionInput>>>;
  questionHash?: Maybe<Scalars['String']>;
};

export type ComponentComponentsAnswerOption = {
  __typename?: 'ComponentComponentsAnswerOption';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type ComponentComponentsAnswerOptionFiltersInput = {
  title?: Maybe<StringFilterInput>;
  and?: Maybe<Array<Maybe<ComponentComponentsAnswerOptionFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentComponentsAnswerOptionFiltersInput>>>;
  not?: Maybe<ComponentComponentsAnswerOptionFiltersInput>;
};

export type ComponentComponentsAnswerOptionInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
};

export type ComponentComponentsAvailableJobs = {
  __typename?: 'ComponentComponentsAvailableJobs';
  id: Scalars['ID'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};

export type ComponentComponentsBanner = {
  __typename?: 'ComponentComponentsBanner';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  image?: Maybe<UploadFile>;
  type?: Maybe<Enum_Componentcomponentsbanner_Type>;
  description?: Maybe<Scalars['String']>;
};

export type ComponentComponentsBlog = {
  __typename?: 'ComponentComponentsBlog';
  id: Scalars['ID'];
  background?: Maybe<Enum_Componentcomponentsblog_Background>;
  title?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  post?: Maybe<Blog>;
};

export type ComponentComponentsBudgetForm = {
  __typename?: 'ComponentComponentsBudgetForm';
  id: Scalars['ID'];
  background?: Maybe<Enum_Componentcomponentsbudgetform_Background>;
};

export type ComponentComponentsButton = {
  __typename?: 'ComponentComponentsButton';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  action?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Componentcomponentsbutton_Type>;
};

export type ComponentComponentsButtonFiltersInput = {
  title?: Maybe<StringFilterInput>;
  action?: Maybe<StringFilterInput>;
  type?: Maybe<StringFilterInput>;
  and?: Maybe<Array<Maybe<ComponentComponentsButtonFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentComponentsButtonFiltersInput>>>;
  not?: Maybe<ComponentComponentsButtonFiltersInput>;
};

export type ComponentComponentsCardDisplay = {
  __typename?: 'ComponentComponentsCardDisplay';
  id: Scalars['ID'];
  columns?: Maybe<Scalars['Int']>;
  background?: Maybe<Enum_Componentcomponentscarddisplay_Background>;
  ghost?: Maybe<Scalars['Boolean']>;
  flat?: Maybe<Scalars['Boolean']>;
  cards?: Maybe<Array<Maybe<ComponentComponentsCardItem>>>;
};


export type ComponentComponentsCardDisplayCardsArgs = {
  filters?: Maybe<ComponentComponentsCardItemFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentComponentsCardItem = {
  __typename?: 'ComponentComponentsCardItem';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<UploadFile>;
};

export type ComponentComponentsCardItemFiltersInput = {
  title?: Maybe<StringFilterInput>;
  description?: Maybe<StringFilterInput>;
  and?: Maybe<Array<Maybe<ComponentComponentsCardItemFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentComponentsCardItemFiltersInput>>>;
  not?: Maybe<ComponentComponentsCardItemFiltersInput>;
};

export type ComponentComponentsCards = {
  __typename?: 'ComponentComponentsCards';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  showNumber?: Maybe<Scalars['Boolean']>;
  icon?: Maybe<UploadFile>;
};

export type ComponentComponentsCardsFiltersInput = {
  title?: Maybe<StringFilterInput>;
  content?: Maybe<StringFilterInput>;
  showNumber?: Maybe<BooleanFilterInput>;
  and?: Maybe<Array<Maybe<ComponentComponentsCardsFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentComponentsCardsFiltersInput>>>;
  not?: Maybe<ComponentComponentsCardsFiltersInput>;
};

export type ComponentComponentsCompanyForm = {
  __typename?: 'ComponentComponentsCompanyForm';
  id: Scalars['ID'];
  background?: Maybe<Enum_Componentcomponentscompanyform_Background>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  destinationUrl?: Maybe<Scalars['String']>;
  hideMessage?: Maybe<Scalars['Boolean']>;
  buttonText?: Maybe<Scalars['String']>;
  hubspotFormId?: Maybe<Scalars['String']>;
  hidePhone?: Maybe<Scalars['Boolean']>;
  sendToEmail?: Maybe<Scalars['Boolean']>;
  gtagConversionEvent?: Maybe<Scalars['String']>;
};

export type ComponentComponentsComponents = {
  __typename?: 'ComponentComponentsComponents';
  id: Scalars['ID'];
  test?: Maybe<Scalars['String']>;
};

export type ComponentComponentsContactCard = {
  __typename?: 'ComponentComponentsContactCard';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type ComponentComponentsContactForm = {
  __typename?: 'ComponentComponentsContactForm';
  id: Scalars['ID'];
  background?: Maybe<Enum_Componentcomponentscontactform_Background>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  destinationUrl?: Maybe<Scalars['String']>;
  hideMessage?: Maybe<Scalars['Boolean']>;
  buttonText?: Maybe<Scalars['String']>;
  hubspotFormId?: Maybe<Scalars['String']>;
  hidePhone?: Maybe<Scalars['Boolean']>;
  sendToEmail?: Maybe<Scalars['Boolean']>;
  gtagConversionEvent?: Maybe<Scalars['String']>;
};

export type ComponentComponentsContent = {
  __typename?: 'ComponentComponentsContent';
  id: Scalars['ID'];
  content: Scalars['String'];
  linkText?: Maybe<Scalars['String']>;
  linkDestination?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
};

export type ComponentComponentsContentFiltersInput = {
  content?: Maybe<StringFilterInput>;
  linkText?: Maybe<StringFilterInput>;
  linkDestination?: Maybe<StringFilterInput>;
  icon?: Maybe<StringFilterInput>;
  and?: Maybe<Array<Maybe<ComponentComponentsContentFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentComponentsContentFiltersInput>>>;
  not?: Maybe<ComponentComponentsContentFiltersInput>;
};

export type ComponentComponentsContents = {
  __typename?: 'ComponentComponentsContents';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
};

export type ComponentComponentsContentsFiltersInput = {
  title?: Maybe<StringFilterInput>;
  body?: Maybe<StringFilterInput>;
  and?: Maybe<Array<Maybe<ComponentComponentsContentsFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentComponentsContentsFiltersInput>>>;
  not?: Maybe<ComponentComponentsContentsFiltersInput>;
};

export type ComponentComponentsDescriptionSection = {
  __typename?: 'ComponentComponentsDescriptionSection';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type ComponentComponentsDescriptionSectionFiltersInput = {
  title?: Maybe<StringFilterInput>;
  description?: Maybe<StringFilterInput>;
  and?: Maybe<Array<Maybe<ComponentComponentsDescriptionSectionFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentComponentsDescriptionSectionFiltersInput>>>;
  not?: Maybe<ComponentComponentsDescriptionSectionFiltersInput>;
};

export type ComponentComponentsDescriptionSectionInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type ComponentComponentsDevelopmentDetails = {
  __typename?: 'ComponentComponentsDevelopmentDetails';
  id: Scalars['ID'];
  devTime?: Maybe<Scalars['Long']>;
  devCommits?: Maybe<Scalars['Long']>;
  devMonths?: Maybe<Scalars['Int']>;
  whereToFind?: Maybe<Array<Maybe<ComponentComponentsWhereToFind>>>;
  background?: Maybe<Enum_Componentcomponentsdevelopmentdetails_Background>;
};


export type ComponentComponentsDevelopmentDetailsWhereToFindArgs = {
  filters?: Maybe<ComponentComponentsWhereToFindFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentComponentsDottedList = {
  __typename?: 'ComponentComponentsDottedList';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  background?: Maybe<Enum_Componentcomponentsdottedlist_Background>;
  topics?: Maybe<Array<Maybe<ComponentComponentsDottedListItem>>>;
  image?: Maybe<UploadFile>;
  type?: Maybe<Enum_Componentcomponentsdottedlist_Type>;
};


export type ComponentComponentsDottedListTopicsArgs = {
  filters?: Maybe<ComponentComponentsDottedListItemFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentComponentsDottedListItem = {
  __typename?: 'ComponentComponentsDottedListItem';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
};

export type ComponentComponentsDottedListItemFiltersInput = {
  title?: Maybe<StringFilterInput>;
  body?: Maybe<StringFilterInput>;
  and?: Maybe<Array<Maybe<ComponentComponentsDottedListItemFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentComponentsDottedListItemFiltersInput>>>;
  not?: Maybe<ComponentComponentsDottedListItemFiltersInput>;
};

export type ComponentComponentsEventList = {
  __typename?: 'ComponentComponentsEventList';
  id: Scalars['ID'];
  sort?: Maybe<Enum_Componentcomponentseventlist_Sort>;
  location?: Maybe<Enum_Componentcomponentseventlist_Location>;
  year?: Maybe<Scalars['String']>;
  timing?: Maybe<Enum_Componentcomponentseventlist_Timing>;
};

export type ComponentComponentsForm = {
  __typename?: 'ComponentComponentsForm';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  FormFields?: Maybe<Array<Maybe<ComponentComponentsFormFields>>>;
  button?: Maybe<Scalars['String']>;
  formName?: Maybe<Scalars['String']>;
  background?: Maybe<Enum_Componentcomponentsform_Background>;
};


export type ComponentComponentsFormFormFieldsArgs = {
  filters?: Maybe<ComponentComponentsFormFieldsFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentComponentsFormFields = {
  __typename?: 'ComponentComponentsFormFields';
  id: Scalars['ID'];
  placeholder?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Componentcomponentsformfields_Type>;
};

export type ComponentComponentsFormFieldsFiltersInput = {
  placeholder?: Maybe<StringFilterInput>;
  type?: Maybe<StringFilterInput>;
  and?: Maybe<Array<Maybe<ComponentComponentsFormFieldsFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentComponentsFormFieldsFiltersInput>>>;
  not?: Maybe<ComponentComponentsFormFieldsFiltersInput>;
};

export type ComponentComponentsFormSection = {
  __typename?: 'ComponentComponentsFormSection';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  promptCommon?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Maybe<ComponentComponentsQuestion>>>;
  conditionalShowQuestion?: Maybe<Scalars['String']>;
  conditionalShowAnswer?: Maybe<Scalars['String']>;
  promptQuestion?: Maybe<Scalars['String']>;
  promptResult?: Maybe<Scalars['String']>;
  loaderText?: Maybe<Scalars['String']>;
};


export type ComponentComponentsFormSectionQuestionsArgs = {
  filters?: Maybe<ComponentComponentsQuestionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentComponentsFormSectionFiltersInput = {
  title?: Maybe<StringFilterInput>;
  description?: Maybe<StringFilterInput>;
  promptCommon?: Maybe<StringFilterInput>;
  questions?: Maybe<ComponentComponentsQuestionFiltersInput>;
  conditionalShowQuestion?: Maybe<StringFilterInput>;
  conditionalShowAnswer?: Maybe<StringFilterInput>;
  promptQuestion?: Maybe<StringFilterInput>;
  promptResult?: Maybe<StringFilterInput>;
  loaderText?: Maybe<StringFilterInput>;
  and?: Maybe<Array<Maybe<ComponentComponentsFormSectionFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentComponentsFormSectionFiltersInput>>>;
  not?: Maybe<ComponentComponentsFormSectionFiltersInput>;
};

export type ComponentComponentsFormSectionInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  promptCommon?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Maybe<ComponentComponentsQuestionInput>>>;
  conditionalShowQuestion?: Maybe<Scalars['String']>;
  conditionalShowAnswer?: Maybe<Scalars['String']>;
  promptQuestion?: Maybe<Scalars['String']>;
  promptResult?: Maybe<Scalars['String']>;
  loaderText?: Maybe<Scalars['String']>;
};

export type ComponentComponentsFormSectionWithAnswers = {
  __typename?: 'ComponentComponentsFormSectionWithAnswers';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  promptCommon?: Maybe<Scalars['String']>;
  answers?: Maybe<Array<Maybe<ComponentComponentsAnswer>>>;
  conditionalShowQuestion?: Maybe<Scalars['String']>;
  conditionalShowAnswer?: Maybe<Scalars['String']>;
  promptQuestion?: Maybe<Scalars['String']>;
  promptResult?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  loaderText?: Maybe<Scalars['String']>;
};


export type ComponentComponentsFormSectionWithAnswersAnswersArgs = {
  filters?: Maybe<ComponentComponentsAnswerFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentComponentsFormSectionWithAnswersFiltersInput = {
  title?: Maybe<StringFilterInput>;
  description?: Maybe<StringFilterInput>;
  promptCommon?: Maybe<StringFilterInput>;
  answers?: Maybe<ComponentComponentsAnswerFiltersInput>;
  conditionalShowQuestion?: Maybe<StringFilterInput>;
  conditionalShowAnswer?: Maybe<StringFilterInput>;
  promptQuestion?: Maybe<StringFilterInput>;
  promptResult?: Maybe<StringFilterInput>;
  result?: Maybe<StringFilterInput>;
  loaderText?: Maybe<StringFilterInput>;
  and?: Maybe<Array<Maybe<ComponentComponentsFormSectionWithAnswersFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentComponentsFormSectionWithAnswersFiltersInput>>>;
  not?: Maybe<ComponentComponentsFormSectionWithAnswersFiltersInput>;
};

export type ComponentComponentsFormSectionWithAnswersInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  promptCommon?: Maybe<Scalars['String']>;
  answers?: Maybe<Array<Maybe<ComponentComponentsAnswerInput>>>;
  conditionalShowQuestion?: Maybe<Scalars['String']>;
  conditionalShowAnswer?: Maybe<Scalars['String']>;
  promptQuestion?: Maybe<Scalars['String']>;
  promptResult?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  loaderText?: Maybe<Scalars['String']>;
};

export type ComponentComponentsGallery = {
  __typename?: 'ComponentComponentsGallery';
  id: Scalars['ID'];
  gallery_connection?: Maybe<UploadFileRelationResponseCollection>;
  gallery: Array<Maybe<UploadFile>>;
  size?: Maybe<Enum_Componentcomponentsgallery_Size>;
  columns?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  galleryImagePosition?: Maybe<Enum_Componentcomponentsgallery_Galleryimageposition>;
  isCarousel?: Maybe<Scalars['Boolean']>;
  carouselBackground?: Maybe<Enum_Componentcomponentsgallery_Carouselbackground>;
  carouselWidth?: Maybe<Enum_Componentcomponentsgallery_Carouselwidth>;
  richTextId?: Maybe<Scalars['String']>;
};


export type ComponentComponentsGalleryGallery_ConnectionArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ComponentComponentsGalleryGalleryArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentComponentsGetInTouch = {
  __typename?: 'ComponentComponentsGetInTouch';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  button?: Maybe<Scalars['String']>;
  background?: Maybe<Enum_Componentcomponentsgetintouch_Background>;
};

export type ComponentComponentsGlassdoor = {
  __typename?: 'ComponentComponentsGlassdoor';
  id: Scalars['ID'];
  image?: Maybe<UploadFile>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  background?: Maybe<Enum_Componentcomponentsglassdoor_Background>;
};

export type ComponentComponentsHubspotMeeting = {
  __typename?: 'ComponentComponentsHubspotMeeting';
  id: Scalars['ID'];
  meetingSlug?: Maybe<Scalars['String']>;
  background?: Maybe<Enum_Componentcomponentshubspotmeeting_Background>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  gtagConversionEvent?: Maybe<Scalars['String']>;
};

export type ComponentComponentsItems = {
  __typename?: 'ComponentComponentsItems';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type ComponentComponentsItemsFiltersInput = {
  title?: Maybe<StringFilterInput>;
  text?: Maybe<StringFilterInput>;
  and?: Maybe<Array<Maybe<ComponentComponentsItemsFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentComponentsItemsFiltersInput>>>;
  not?: Maybe<ComponentComponentsItemsFiltersInput>;
};

export type ComponentComponentsMenuItems = {
  __typename?: 'ComponentComponentsMenuItems';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ComponentComponentsMenuItemsFiltersInput = {
  label?: Maybe<StringFilterInput>;
  url?: Maybe<StringFilterInput>;
  and?: Maybe<Array<Maybe<ComponentComponentsMenuItemsFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentComponentsMenuItemsFiltersInput>>>;
  not?: Maybe<ComponentComponentsMenuItemsFiltersInput>;
};

export type ComponentComponentsMenuItemsInput = {
  id?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ComponentComponentsMetadata = {
  __typename?: 'ComponentComponentsMetadata';
  id: Scalars['ID'];
  metaTitle?: Maybe<Scalars['String']>;
  metaDescription?: Maybe<Scalars['String']>;
  metaImage?: Maybe<UploadFile>;
  hideAppMastersTitle?: Maybe<Scalars['Boolean']>;
  llms?: Maybe<Scalars['String']>;
};

export type ComponentComponentsMetadataFiltersInput = {
  metaTitle?: Maybe<StringFilterInput>;
  metaDescription?: Maybe<StringFilterInput>;
  hideAppMastersTitle?: Maybe<BooleanFilterInput>;
  llms?: Maybe<StringFilterInput>;
  and?: Maybe<Array<Maybe<ComponentComponentsMetadataFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentComponentsMetadataFiltersInput>>>;
  not?: Maybe<ComponentComponentsMetadataFiltersInput>;
};

export type ComponentComponentsMetadataInput = {
  id?: Maybe<Scalars['ID']>;
  metaTitle?: Maybe<Scalars['String']>;
  metaDescription?: Maybe<Scalars['String']>;
  metaImage?: Maybe<Scalars['ID']>;
  hideAppMastersTitle?: Maybe<Scalars['Boolean']>;
  llms?: Maybe<Scalars['String']>;
};

export type ComponentComponentsNumberSlider = {
  __typename?: 'ComponentComponentsNumberSlider';
  id: Scalars['ID'];
  allowmore?: Maybe<Scalars['Boolean']>;
  minimum: Scalars['Int'];
  maximum: Scalars['Int'];
};

export type ComponentComponentsProjectsList = {
  __typename?: 'ComponentComponentsProjectsList';
  id: Scalars['ID'];
  filter?: Maybe<Enum_Componentcomponentsprojectslist_Filter>;
  limit?: Maybe<Scalars['Int']>;
  background?: Maybe<Enum_Componentcomponentsprojectslist_Background>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type ComponentComponentsQuestion = {
  __typename?: 'ComponentComponentsQuestion';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  hint?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Enum_Componentcomponentsquestion_Type>;
  answerOptions?: Maybe<Array<Maybe<ComponentComponentsAnswerOption>>>;
  hash?: Maybe<Scalars['String']>;
  allowMore?: Maybe<Scalars['Boolean']>;
  minimum?: Maybe<Scalars['Int']>;
  maximum?: Maybe<Scalars['Int']>;
  steper?: Maybe<Scalars['Int']>;
};


export type ComponentComponentsQuestionAnswerOptionsArgs = {
  filters?: Maybe<ComponentComponentsAnswerOptionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentComponentsQuestionFiltersInput = {
  title?: Maybe<StringFilterInput>;
  hint?: Maybe<StringFilterInput>;
  required?: Maybe<BooleanFilterInput>;
  type?: Maybe<StringFilterInput>;
  answerOptions?: Maybe<ComponentComponentsAnswerOptionFiltersInput>;
  hash?: Maybe<StringFilterInput>;
  allowMore?: Maybe<BooleanFilterInput>;
  minimum?: Maybe<IntFilterInput>;
  maximum?: Maybe<IntFilterInput>;
  steper?: Maybe<IntFilterInput>;
  and?: Maybe<Array<Maybe<ComponentComponentsQuestionFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentComponentsQuestionFiltersInput>>>;
  not?: Maybe<ComponentComponentsQuestionFiltersInput>;
};

export type ComponentComponentsQuestionInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  hint?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Enum_Componentcomponentsquestion_Type>;
  answerOptions?: Maybe<Array<Maybe<ComponentComponentsAnswerOptionInput>>>;
  hash?: Maybe<Scalars['String']>;
  allowMore?: Maybe<Scalars['Boolean']>;
  minimum?: Maybe<Scalars['Int']>;
  maximum?: Maybe<Scalars['Int']>;
  steper?: Maybe<Scalars['Int']>;
};

export type ComponentComponentsRichtext = {
  __typename?: 'ComponentComponentsRichtext';
  id: Scalars['ID'];
  body?: Maybe<Scalars['String']>;
  background?: Maybe<Enum_Componentcomponentsrichtext_Background>;
  textColor?: Maybe<Scalars['String']>;
  titleColor?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['Boolean']>;
  image?: Maybe<UploadFile>;
};

export type ComponentComponentsSection = {
  __typename?: 'ComponentComponentsSection';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  titleBold?: Maybe<Scalars['Boolean']>;
  background?: Maybe<Enum_Componentcomponentssection_Background>;
  subtitle?: Maybe<Scalars['String']>;
  cardDisplay?: Maybe<ComponentComponentsCardDisplay>;
  gallery_connection?: Maybe<UploadFileRelationResponseCollection>;
  gallery: Array<Maybe<UploadFile>>;
  galleryImagePosition?: Maybe<Enum_Componentcomponentssection_Galleryimageposition>;
  service?: Maybe<ComponentComponentsService>;
  button?: Maybe<Array<Maybe<ComponentComponentsButton>>>;
  buttonDirection?: Maybe<Enum_Componentcomponentssection_Buttondirection>;
  backgroundImage?: Maybe<UploadFile>;
};


export type ComponentComponentsSectionGallery_ConnectionArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ComponentComponentsSectionGalleryArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ComponentComponentsSectionButtonArgs = {
  filters?: Maybe<ComponentComponentsButtonFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentComponentsSectionBackgroundImageRichText = {
  __typename?: 'ComponentComponentsSectionBackgroundImageRichText';
  id: Scalars['ID'];
  text?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<UploadFile>;
  textPosition?: Maybe<Enum_Componentcomponentssectionbackgroundimagerichtext_Textposition>;
};

export type ComponentComponentsSectionCards = {
  __typename?: 'ComponentComponentsSectionCards';
  id: Scalars['ID'];
  content?: Maybe<Scalars['String']>;
  cardsPosition?: Maybe<Enum_Componentcomponentssectioncards_Cardsposition>;
  sectionCard?: Maybe<Array<Maybe<ComponentComponentsCards>>>;
  actionLink?: Maybe<ComponentComponentsActionLink>;
  backgroundColor?: Maybe<Enum_Componentcomponentssectioncards_Backgroundcolor>;
};


export type ComponentComponentsSectionCardsSectionCardArgs = {
  filters?: Maybe<ComponentComponentsCardsFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentComponentsSectionImageRichText = {
  __typename?: 'ComponentComponentsSectionImageRichText';
  id: Scalars['ID'];
  text?: Maybe<Scalars['String']>;
  image?: Maybe<UploadFile>;
  imageFit?: Maybe<Enum_Componentcomponentssectionimagerichtext_Imagefit>;
  imageProportion?: Maybe<Enum_Componentcomponentssectionimagerichtext_Imageproportion>;
  backgroundColor?: Maybe<Enum_Componentcomponentssectionimagerichtext_Backgroundcolor>;
};

export type ComponentComponentsSectionImageRichTextList = {
  __typename?: 'ComponentComponentsSectionImageRichTextList';
  id: Scalars['ID'];
  mediaType?: Maybe<Enum_Componentcomponentssectionimagerichtextlist_Mediatype>;
  SectionImageRichTextListItems: Array<Maybe<ComponentComponentsSectionImageRichTextListItem>>;
};


export type ComponentComponentsSectionImageRichTextListSectionImageRichTextListItemsArgs = {
  filters?: Maybe<ComponentComponentsSectionImageRichTextListItemFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentComponentsSectionImageRichTextListItem = {
  __typename?: 'ComponentComponentsSectionImageRichTextListItem';
  id: Scalars['ID'];
  text?: Maybe<Scalars['String']>;
  image?: Maybe<UploadFile>;
};

export type ComponentComponentsSectionImageRichTextListItemFiltersInput = {
  text?: Maybe<StringFilterInput>;
  and?: Maybe<Array<Maybe<ComponentComponentsSectionImageRichTextListItemFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentComponentsSectionImageRichTextListItemFiltersInput>>>;
  not?: Maybe<ComponentComponentsSectionImageRichTextListItemFiltersInput>;
};

export type ComponentComponentsSectionQuote = {
  __typename?: 'ComponentComponentsSectionQuote';
  id: Scalars['ID'];
  text?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Enum_Componentcomponentssectionquote_Backgroundcolor>;
  richTextId?: Maybe<Scalars['String']>;
};

export type ComponentComponentsSectionTextButtons = {
  __typename?: 'ComponentComponentsSectionTextButtons';
  id: Scalars['ID'];
  text?: Maybe<Scalars['String']>;
  buttonsAlignment?: Maybe<Enum_Componentcomponentssectiontextbuttons_Buttonsalignment>;
  buttons?: Maybe<Array<Maybe<ComponentComponentsButton>>>;
  backgroundColor?: Maybe<Enum_Componentcomponentssectiontextbuttons_Backgroundcolor>;
};


export type ComponentComponentsSectionTextButtonsButtonsArgs = {
  filters?: Maybe<ComponentComponentsButtonFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentComponentsSectionTextColumns = {
  __typename?: 'ComponentComponentsSectionTextColumns';
  id: Scalars['ID'];
  backgroundColor?: Maybe<Enum_Componentcomponentssectiontextcolumns_Backgroundcolor>;
  content?: Maybe<Array<Maybe<ComponentComponentsContent>>>;
};


export type ComponentComponentsSectionTextColumnsContentArgs = {
  filters?: Maybe<ComponentComponentsContentFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentComponentsSectionTitleItemList = {
  __typename?: 'ComponentComponentsSectionTitleItemList';
  id: Scalars['ID'];
  text?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Enum_Componentcomponentssectiontitleitemlist_Backgroundcolor>;
  listType?: Maybe<Enum_Componentcomponentssectiontitleitemlist_Listtype>;
  items?: Maybe<Array<Maybe<ComponentComponentsItems>>>;
  contentOrientation?: Maybe<Enum_Componentcomponentssectiontitleitemlist_Contentorientation>;
};


export type ComponentComponentsSectionTitleItemListItemsArgs = {
  filters?: Maybe<ComponentComponentsItemsFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentComponentsService = {
  __typename?: 'ComponentComponentsService';
  id: Scalars['ID'];
  invert?: Maybe<Scalars['Boolean']>;
  serviceItens?: Maybe<Array<Maybe<ComponentComponentsServiceItem>>>;
};


export type ComponentComponentsServiceServiceItensArgs = {
  filters?: Maybe<ComponentComponentsServiceItemFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentComponentsServiceItem = {
  __typename?: 'ComponentComponentsServiceItem';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  image?: Maybe<UploadFile>;
};

export type ComponentComponentsServiceItemFiltersInput = {
  title?: Maybe<StringFilterInput>;
  body?: Maybe<StringFilterInput>;
  and?: Maybe<Array<Maybe<ComponentComponentsServiceItemFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentComponentsServiceItemFiltersInput>>>;
  not?: Maybe<ComponentComponentsServiceItemFiltersInput>;
};

export type ComponentComponentsTeamCalculator = {
  __typename?: 'ComponentComponentsTeamCalculator';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type ComponentComponentsTechnologies = {
  __typename?: 'ComponentComponentsTechnologies';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  background?: Maybe<Enum_Componentcomponentstechnologies_Background>;
  textAlign?: Maybe<Enum_Componentcomponentstechnologies_Textalign>;
  numberOfColumns?: Maybe<Scalars['Int']>;
  featured?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  button?: Maybe<ComponentComponentsButton>;
  stackshareUrl?: Maybe<Scalars['String']>;
  technologies_connection?: Maybe<TechnologyRelationResponseCollection>;
  technologies: Array<Maybe<Technology>>;
  type?: Maybe<Enum_Componentcomponentstechnologies_Type>;
  tiny?: Maybe<Scalars['Boolean']>;
};


export type ComponentComponentsTechnologiesTechnologies_ConnectionArgs = {
  filters?: Maybe<TechnologyFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ComponentComponentsTechnologiesTechnologiesArgs = {
  filters?: Maybe<TechnologyFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentComponentsTestimonialDetail = {
  __typename?: 'ComponentComponentsTestimonialDetail';
  id: Scalars['ID'];
  displayName?: Maybe<Scalars['String']>;
  occupation?: Maybe<Scalars['String']>;
  image?: Maybe<UploadFile>;
  companyName?: Maybe<Scalars['String']>;
  testimony?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Componentcomponentstestimonialdetail_Type>;
  clientCountry?: Maybe<Enum_Componentcomponentstestimonialdetail_Clientcountry>;
  name?: Maybe<Scalars['String']>;
  cardBackground?: Maybe<Enum_Componentcomponentstestimonialdetail_Cardbackground>;
};

export type ComponentComponentsTextWithSideList = {
  __typename?: 'ComponentComponentsTextWithSideList';
  id: Scalars['ID'];
  body?: Maybe<Scalars['String']>;
  textAlign?: Maybe<Enum_Componentcomponentstextwithsidelist_Textalign>;
  itemsCard?: Maybe<ComponentComponentsDottedList>;
  background?: Maybe<Enum_Componentcomponentstextwithsidelist_Background>;
};

export type ComponentComponentsTimeline = {
  __typename?: 'ComponentComponentsTimeline';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  background?: Maybe<Enum_Componentcomponentstimeline_Background>;
  gallery_connection?: Maybe<UploadFileRelationResponseCollection>;
  gallery: Array<Maybe<UploadFile>>;
  disableSticky?: Maybe<Scalars['Boolean']>;
  disableImageOverflow?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  contents?: Maybe<Array<Maybe<ComponentComponentsContents>>>;
  footer?: Maybe<Scalars['String']>;
};


export type ComponentComponentsTimelineGallery_ConnectionArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ComponentComponentsTimelineGalleryArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ComponentComponentsTimelineContentsArgs = {
  filters?: Maybe<ComponentComponentsContentsFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentComponentsUserTestimony = {
  __typename?: 'ComponentComponentsUserTestimony';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  compact?: Maybe<Scalars['Boolean']>;
  subtitle?: Maybe<Scalars['String']>;
  testimoniesType?: Maybe<Enum_Componentcomponentsusertestimony_Testimoniestype>;
  limit?: Maybe<Scalars['Int']>;
  testimonies_connection?: Maybe<TestimonyRelationResponseCollection>;
  testimonies: Array<Maybe<Testimony>>;
  cardBackground?: Maybe<Enum_Componentcomponentsusertestimony_Cardbackground>;
  columns?: Maybe<Scalars['Int']>;
  backgroundColor?: Maybe<Enum_Componentcomponentsusertestimony_Backgroundcolor>;
};


export type ComponentComponentsUserTestimonyTestimonies_ConnectionArgs = {
  filters?: Maybe<TestimonyFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ComponentComponentsUserTestimonyTestimoniesArgs = {
  filters?: Maybe<TestimonyFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentComponentsWhereToFind = {
  __typename?: 'ComponentComponentsWhereToFind';
  id: Scalars['ID'];
  link?: Maybe<Scalars['String']>;
  image?: Maybe<UploadFile>;
};

export type ComponentComponentsWhereToFindFiltersInput = {
  link?: Maybe<StringFilterInput>;
  and?: Maybe<Array<Maybe<ComponentComponentsWhereToFindFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentComponentsWhereToFindFiltersInput>>>;
  not?: Maybe<ComponentComponentsWhereToFindFiltersInput>;
};

export type Course = {
  __typename?: 'Course';
  documentId: Scalars['ID'];
  title: Scalars['String'];
  slug: Scalars['String'];
  meta?: Maybe<ComponentComponentsMetadata>;
  description?: Maybe<Scalars['String']>;
  category?: Maybe<Enum_Course_Category>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  period?: Maybe<Scalars['String']>;
  maxStudents?: Maybe<Scalars['Int']>;
  remote?: Maybe<Scalars['Boolean']>;
  placeName?: Maybe<Scalars['String']>;
  placeAddress?: Maybe<Scalars['String']>;
  googleMapsUrl?: Maybe<Scalars['String']>;
  subscriptionType?: Maybe<Enum_Course_Subscriptiontype>;
  curriculum?: Maybe<Array<Maybe<ComponentAcademyCurriculumList>>>;
  price?: Maybe<Scalars['Float']>;
  preSubscription?: Maybe<Scalars['Boolean']>;
  shortDescription?: Maybe<Scalars['String']>;
  skillLevel?: Maybe<Enum_Course_Skilllevel>;
  confirmatedEmail?: Maybe<Scalars['String']>;
  subscribedStudents?: Maybe<Scalars['Int']>;
  confirmedStudents?: Maybe<Scalars['Int']>;
  authors_connection?: Maybe<AuthorRelationResponseCollection>;
  authors: Array<Maybe<Author>>;
  subscriptions_connection?: Maybe<SubscriptionRelationResponseCollection>;
  subscriptions: Array<Maybe<Subscription>>;
  image?: Maybe<UploadFile>;
  paymentUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations_connection?: Maybe<CourseRelationResponseCollection>;
  localizations: Array<Maybe<Course>>;
};


export type CourseCurriculumArgs = {
  filters?: Maybe<ComponentAcademyCurriculumListFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CourseAuthors_ConnectionArgs = {
  filters?: Maybe<AuthorFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CourseAuthorsArgs = {
  filters?: Maybe<AuthorFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CourseSubscriptions_ConnectionArgs = {
  filters?: Maybe<SubscriptionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CourseSubscriptionsArgs = {
  filters?: Maybe<SubscriptionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CourseLocalizations_ConnectionArgs = {
  filters?: Maybe<CourseFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CourseLocalizationsArgs = {
  filters?: Maybe<CourseFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CourseEntityResponseCollection = {
  __typename?: 'CourseEntityResponseCollection';
  nodes: Array<Course>;
  pageInfo: Pagination;
};

export type CourseFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  title?: Maybe<StringFilterInput>;
  slug?: Maybe<StringFilterInput>;
  meta?: Maybe<ComponentComponentsMetadataFiltersInput>;
  description?: Maybe<StringFilterInput>;
  category?: Maybe<StringFilterInput>;
  startDate?: Maybe<DateFilterInput>;
  endDate?: Maybe<DateFilterInput>;
  period?: Maybe<StringFilterInput>;
  maxStudents?: Maybe<IntFilterInput>;
  remote?: Maybe<BooleanFilterInput>;
  placeName?: Maybe<StringFilterInput>;
  placeAddress?: Maybe<StringFilterInput>;
  googleMapsUrl?: Maybe<StringFilterInput>;
  subscriptionType?: Maybe<StringFilterInput>;
  curriculum?: Maybe<ComponentAcademyCurriculumListFiltersInput>;
  price?: Maybe<FloatFilterInput>;
  preSubscription?: Maybe<BooleanFilterInput>;
  shortDescription?: Maybe<StringFilterInput>;
  skillLevel?: Maybe<StringFilterInput>;
  confirmatedEmail?: Maybe<StringFilterInput>;
  subscribedStudents?: Maybe<IntFilterInput>;
  confirmedStudents?: Maybe<IntFilterInput>;
  authors?: Maybe<AuthorFiltersInput>;
  subscriptions?: Maybe<SubscriptionFiltersInput>;
  paymentUrl?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  locale?: Maybe<StringFilterInput>;
  localizations?: Maybe<CourseFiltersInput>;
  and?: Maybe<Array<Maybe<CourseFiltersInput>>>;
  or?: Maybe<Array<Maybe<CourseFiltersInput>>>;
  not?: Maybe<CourseFiltersInput>;
};

export type CourseInput = {
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  meta?: Maybe<ComponentComponentsMetadataInput>;
  description?: Maybe<Scalars['String']>;
  category?: Maybe<Enum_Course_Category>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  period?: Maybe<Scalars['String']>;
  maxStudents?: Maybe<Scalars['Int']>;
  remote?: Maybe<Scalars['Boolean']>;
  placeName?: Maybe<Scalars['String']>;
  placeAddress?: Maybe<Scalars['String']>;
  googleMapsUrl?: Maybe<Scalars['String']>;
  subscriptionType?: Maybe<Enum_Course_Subscriptiontype>;
  curriculum?: Maybe<Array<Maybe<ComponentAcademyCurriculumListInput>>>;
  price?: Maybe<Scalars['Float']>;
  preSubscription?: Maybe<Scalars['Boolean']>;
  shortDescription?: Maybe<Scalars['String']>;
  skillLevel?: Maybe<Enum_Course_Skilllevel>;
  confirmatedEmail?: Maybe<Scalars['String']>;
  subscribedStudents?: Maybe<Scalars['Int']>;
  confirmedStudents?: Maybe<Scalars['Int']>;
  authors?: Maybe<Array<Maybe<Scalars['ID']>>>;
  subscriptions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  image?: Maybe<Scalars['ID']>;
  paymentUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type CourseRelationResponseCollection = {
  __typename?: 'CourseRelationResponseCollection';
  nodes: Array<Course>;
};


export type DateFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['Date']>>>;
  or?: Maybe<Array<Maybe<Scalars['Date']>>>;
  not?: Maybe<DateFilterInput>;
  eq?: Maybe<Scalars['Date']>;
  eqi?: Maybe<Scalars['Date']>;
  ne?: Maybe<Scalars['Date']>;
  nei?: Maybe<Scalars['Date']>;
  startsWith?: Maybe<Scalars['Date']>;
  endsWith?: Maybe<Scalars['Date']>;
  contains?: Maybe<Scalars['Date']>;
  notContains?: Maybe<Scalars['Date']>;
  containsi?: Maybe<Scalars['Date']>;
  notContainsi?: Maybe<Scalars['Date']>;
  gt?: Maybe<Scalars['Date']>;
  gte?: Maybe<Scalars['Date']>;
  lt?: Maybe<Scalars['Date']>;
  lte?: Maybe<Scalars['Date']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['Date']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['Date']>>>;
  between?: Maybe<Array<Maybe<Scalars['Date']>>>;
};


export type DateTimeFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  or?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  not?: Maybe<DateTimeFilterInput>;
  eq?: Maybe<Scalars['DateTime']>;
  eqi?: Maybe<Scalars['DateTime']>;
  ne?: Maybe<Scalars['DateTime']>;
  nei?: Maybe<Scalars['DateTime']>;
  startsWith?: Maybe<Scalars['DateTime']>;
  endsWith?: Maybe<Scalars['DateTime']>;
  contains?: Maybe<Scalars['DateTime']>;
  notContains?: Maybe<Scalars['DateTime']>;
  containsi?: Maybe<Scalars['DateTime']>;
  notContainsi?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  between?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
};

export type DeleteMutationResponse = {
  __typename?: 'DeleteMutationResponse';
  documentId: Scalars['ID'];
};

export enum Enum_Componentcomponentsbanner_Type {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary'
}

export enum Enum_Componentcomponentsblog_Background {
  Primary = 'primary',
  White = 'white',
  Transparent = 'transparent'
}

export enum Enum_Componentcomponentsbudgetform_Background {
  White = 'white',
  Primary = 'primary'
}

export enum Enum_Componentcomponentsbutton_Type {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Transparent = 'transparent',
  Outline = 'outline',
  Default = 'default'
}

export enum Enum_Componentcomponentscarddisplay_Background {
  Transparent = 'transparent',
  White = 'white',
  Primary = 'primary'
}

export enum Enum_Componentcomponentscompanyform_Background {
  Primary = 'primary',
  White = 'white'
}

export enum Enum_Componentcomponentscontactform_Background {
  Primary = 'primary',
  White = 'white'
}

export enum Enum_Componentcomponentsdevelopmentdetails_Background {
  Primary = 'primary',
  Transparent = 'transparent',
  White = 'white'
}

export enum Enum_Componentcomponentsdottedlist_Background {
  Transparent = 'transparent',
  White = 'white',
  Primary = 'primary'
}

export enum Enum_Componentcomponentsdottedlist_Type {
  Card = 'card',
  Simple = 'simple'
}

export enum Enum_Componentcomponentseventlist_Location {
  NoBrasil = 'No_Brasil',
  ForaDoBrasil = 'Fora_do_Brasil'
}

export enum Enum_Componentcomponentseventlist_Sort {
  Asc = 'Asc',
  Desc = 'Desc'
}

export enum Enum_Componentcomponentseventlist_Timing {
  Future = 'Future',
  Past = 'Past'
}

export enum Enum_Componentcomponentsformfields_Type {
  Number = 'number',
  Text = 'text'
}

export enum Enum_Componentcomponentsform_Background {
  Transparent = 'transparent',
  White = 'white',
  Primary = 'primary'
}

export enum Enum_Componentcomponentsgallery_Carouselbackground {
  Primary = 'primary',
  White = 'white',
  Transparent = 'transparent'
}

export enum Enum_Componentcomponentsgallery_Carouselwidth {
  Content = 'content',
  Page = 'page'
}

export enum Enum_Componentcomponentsgallery_Galleryimageposition {
  Covered = 'covered',
  Contained = 'contained'
}

export enum Enum_Componentcomponentsgallery_Size {
  Small = 'small',
  Medium = 'medium',
  Large = 'large'
}

export enum Enum_Componentcomponentsgetintouch_Background {
  Transparent = 'transparent',
  White = 'white',
  Primary = 'primary'
}

export enum Enum_Componentcomponentsglassdoor_Background {
  Transparent = 'transparent',
  White = 'white',
  Primary = 'primary'
}

export enum Enum_Componentcomponentshubspotmeeting_Background {
  Primary = 'primary',
  White = 'white'
}

export enum Enum_Componentcomponentsprojectslist_Background {
  Transparent = 'transparent',
  White = 'white',
  Primary = 'primary'
}

export enum Enum_Componentcomponentsprojectslist_Filter {
  Featured = 'featured',
  Latest = 'latest'
}

export enum Enum_Componentcomponentsquestion_Type {
  MultipleChoiceCheckbox = 'multipleChoiceCheckbox',
  MultipleChoiceRadio = 'multipleChoiceRadio',
  Nps = 'nps',
  FivePointLikertScale = 'fivePointLikertScale',
  OpenShortText = 'openShortText',
  OpenLongText = 'openLongText',
  Boolean = 'boolean',
  NumberSlider = 'numberSlider'
}

export enum Enum_Componentcomponentsrichtext_Background {
  Primary = 'primary',
  White = 'white',
  Transparent = 'transparent'
}

export enum Enum_Componentcomponentssectionbackgroundimagerichtext_Textposition {
  Left = 'left',
  Center = 'center',
  Right = 'right'
}

export enum Enum_Componentcomponentssectioncards_Backgroundcolor {
  Blue = 'blue',
  DarkBlue = 'darkBlue'
}

export enum Enum_Componentcomponentssectioncards_Cardsposition {
  Inline = 'inline',
  Left = 'left',
  Right = 'right'
}

export enum Enum_Componentcomponentssectionimagerichtextlist_Mediatype {
  Image = 'image',
  Icon = 'icon'
}

export enum Enum_Componentcomponentssectionimagerichtext_Backgroundcolor {
  LightGradient = 'lightGradient',
  DarkGradient = 'darkGradient'
}

export enum Enum_Componentcomponentssectionimagerichtext_Imagefit {
  AbsolutBottom = 'absolutBottom',
  AbsolutFull = 'absolutFull',
  CenterAndFit = 'centerAndFit',
  CenterAndCover = 'centerAndCover'
}

export enum Enum_Componentcomponentssectionimagerichtext_Imageproportion {
  OneThird = 'oneThird',
  Half = 'half',
  TwoThirds = 'twoThirds'
}

export enum Enum_Componentcomponentssectionquote_Backgroundcolor {
  LightGradient = 'lightGradient'
}

export enum Enum_Componentcomponentssectiontextbuttons_Backgroundcolor {
  DarkGradient = 'darkGradient',
  LightGradient = 'lightGradient'
}

export enum Enum_Componentcomponentssectiontextbuttons_Buttonsalignment {
  Left = 'left',
  Center = 'center',
  Right = 'right'
}

export enum Enum_Componentcomponentssectiontextcolumns_Backgroundcolor {
  DarkGradient = 'darkGradient',
  DarkBlue = 'darkBlue'
}

export enum Enum_Componentcomponentssectiontitleitemlist_Backgroundcolor {
  White = 'white',
  LightGradient = 'lightGradient'
}

export enum Enum_Componentcomponentssectiontitleitemlist_Contentorientation {
  Row = 'row',
  Column = 'column'
}

export enum Enum_Componentcomponentssectiontitleitemlist_Listtype {
  Numeric = 'numeric',
  Accordion = 'accordion'
}

export enum Enum_Componentcomponentssection_Background {
  Transparent = 'transparent',
  White = 'white',
  Primary = 'primary'
}

export enum Enum_Componentcomponentssection_Buttondirection {
  Horizontal = 'horizontal',
  Vertical = 'vertical'
}

export enum Enum_Componentcomponentssection_Galleryimageposition {
  Covered = 'covered',
  Contained = 'contained'
}

export enum Enum_Componentcomponentstechnologies_Background {
  Primary = 'primary',
  Transparent = 'transparent',
  White = 'white'
}

export enum Enum_Componentcomponentstechnologies_Textalign {
  Left = 'left',
  Center = 'center',
  Right = 'right'
}

export enum Enum_Componentcomponentstechnologies_Type {
  Library = 'Library',
  Service = 'Service'
}

export enum Enum_Componentcomponentstestimonialdetail_Cardbackground {
  White = 'white',
  LightGradient = 'lightGradient',
  DarkGradient = 'darkGradient',
  DarkBlue = 'darkBlue'
}

export enum Enum_Componentcomponentstestimonialdetail_Clientcountry {
  Brasil = 'Brasil',
  Eua = 'EUA',
  Canada = 'Canada',
  Australia = 'Australia'
}

export enum Enum_Componentcomponentstestimonialdetail_Type {
  Client = 'client',
  Founder = 'founder',
  Employee = 'employee',
  Student = 'student'
}

export enum Enum_Componentcomponentstextwithsidelist_Background {
  Primary = 'primary',
  Transparent = 'transparent',
  White = 'white'
}

export enum Enum_Componentcomponentstextwithsidelist_Textalign {
  Left = 'left',
  Top = 'top',
  Right = 'right',
  Bottom = 'bottom'
}

export enum Enum_Componentcomponentstimeline_Background {
  Transparent = 'transparent',
  White = 'white',
  Primary = 'primary'
}

export enum Enum_Componentcomponentsusertestimony_Backgroundcolor {
  White = 'white',
  LightGradient = 'lightGradient',
  DarkGradient = 'darkGradient',
  DarkBlue = 'darkBlue'
}

export enum Enum_Componentcomponentsusertestimony_Cardbackground {
  Default = 'default',
  DarkGradient = 'darkGradient',
  LightGradient = 'lightGradient',
  DarkBlue = 'darkBlue'
}

export enum Enum_Componentcomponentsusertestimony_Testimoniestype {
  Student = 'student',
  Founder = 'founder',
  Client = 'client',
  Employee = 'employee'
}

export enum Enum_Course_Category {
  Backend = 'backend',
  Frontend = 'frontend',
  Web = 'web',
  Mobile = 'mobile',
  InteligenciaArtificial = 'inteligencia_artificial'
}

export enum Enum_Course_Skilllevel {
  Beginner = 'beginner',
  Intermediate = 'intermediate',
  Advanced = 'advanced'
}

export enum Enum_Course_Subscriptiontype {
  Free = 'free',
  Paid = 'paid'
}

export enum Enum_Event_Type {
  Online = 'online',
  Presential = 'presential'
}

export enum Enum_Feedbacksubmission_Type {
  Default = 'default',
  Wizard = 'wizard'
}

export enum Enum_Form_Type {
  Default = 'default',
  Wizard = 'wizard'
}

export enum Enum_Menu_Direction {
  Vertical = 'vertical',
  Horizontal = 'horizontal'
}

export enum Enum_Project_Type {
  Main = 'main',
  Sideproject = 'sideproject'
}

export enum Enum_Service_Background {
  Primary = 'primary',
  Transparent = 'transparent',
  White = 'white'
}

export enum Enum_Subscription_Subscriptionstatus {
  PreSubscribed = 'pre_subscribed',
  Subscribed = 'subscribed',
  Confirmed = 'confirmed',
  Canceled = 'canceled'
}

export enum Enum_Technology_Priority {
  High = 'high',
  Medium = 'medium',
  Low = 'low'
}

export enum Enum_Technology_Type {
  Library = 'Library',
  Service = 'Service'
}

export enum Enum_Testimony_Clientcountry {
  Brasil = 'Brasil',
  Eua = 'EUA',
  Canada = 'Canada',
  Australia = 'Australia'
}

export enum Enum_Testimony_Type {
  Client = 'client',
  Founder = 'founder',
  Employee = 'employee',
  Student = 'student'
}

export type Error = {
  __typename?: 'Error';
  code: Scalars['String'];
  message?: Maybe<Scalars['String']>;
};

export type Event = {
  __typename?: 'Event';
  documentId: Scalars['ID'];
  title: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate?: Maybe<Scalars['DateTime']>;
  country?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Event_Type>;
  url?: Maybe<Scalars['String']>;
  image?: Maybe<UploadFile>;
  description?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  detailPageMessage?: Maybe<Scalars['String']>;
  detailPageUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations_connection?: Maybe<EventRelationResponseCollection>;
  localizations: Array<Maybe<Event>>;
};


export type EventLocalizations_ConnectionArgs = {
  filters?: Maybe<EventFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type EventLocalizationsArgs = {
  filters?: Maybe<EventFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type EventEntityResponseCollection = {
  __typename?: 'EventEntityResponseCollection';
  nodes: Array<Event>;
  pageInfo: Pagination;
};

export type EventFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  title?: Maybe<StringFilterInput>;
  startDate?: Maybe<DateTimeFilterInput>;
  endDate?: Maybe<DateTimeFilterInput>;
  country?: Maybe<StringFilterInput>;
  state?: Maybe<StringFilterInput>;
  city?: Maybe<StringFilterInput>;
  type?: Maybe<StringFilterInput>;
  url?: Maybe<StringFilterInput>;
  description?: Maybe<StringFilterInput>;
  backgroundColor?: Maybe<StringFilterInput>;
  detailPageMessage?: Maybe<StringFilterInput>;
  detailPageUrl?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  locale?: Maybe<StringFilterInput>;
  localizations?: Maybe<EventFiltersInput>;
  and?: Maybe<Array<Maybe<EventFiltersInput>>>;
  or?: Maybe<Array<Maybe<EventFiltersInput>>>;
  not?: Maybe<EventFiltersInput>;
};

export type EventInput = {
  title?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  country?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Event_Type>;
  url?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  detailPageMessage?: Maybe<Scalars['String']>;
  detailPageUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type EventRelationResponseCollection = {
  __typename?: 'EventRelationResponseCollection';
  nodes: Array<Event>;
};

export type FeedbackSubmission = {
  __typename?: 'FeedbackSubmission';
  documentId: Scalars['ID'];
  answers?: Maybe<Array<Maybe<ComponentComponentsAnswer>>>;
  formSlug?: Maybe<Scalars['String']>;
  formTitle?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Feedbacksubmission_Type>;
  additionalInfo?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type FeedbackSubmissionAnswersArgs = {
  filters?: Maybe<ComponentComponentsAnswerFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FeedbackSubmissionEntityResponseCollection = {
  __typename?: 'FeedbackSubmissionEntityResponseCollection';
  nodes: Array<FeedbackSubmission>;
  pageInfo: Pagination;
};

export type FeedbackSubmissionFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  answers?: Maybe<ComponentComponentsAnswerFiltersInput>;
  formSlug?: Maybe<StringFilterInput>;
  formTitle?: Maybe<StringFilterInput>;
  type?: Maybe<StringFilterInput>;
  additionalInfo?: Maybe<JsonFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<FeedbackSubmissionFiltersInput>>>;
  or?: Maybe<Array<Maybe<FeedbackSubmissionFiltersInput>>>;
  not?: Maybe<FeedbackSubmissionFiltersInput>;
};

export type FeedbackSubmissionInput = {
  answers?: Maybe<Array<Maybe<ComponentComponentsAnswerInput>>>;
  formSlug?: Maybe<Scalars['String']>;
  formTitle?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Feedbacksubmission_Type>;
  additionalInfo?: Maybe<Scalars['JSON']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type FileInfoInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
};

export type FloatFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['Float']>>>;
  or?: Maybe<Array<Maybe<Scalars['Float']>>>;
  not?: Maybe<FloatFilterInput>;
  eq?: Maybe<Scalars['Float']>;
  eqi?: Maybe<Scalars['Float']>;
  ne?: Maybe<Scalars['Float']>;
  nei?: Maybe<Scalars['Float']>;
  startsWith?: Maybe<Scalars['Float']>;
  endsWith?: Maybe<Scalars['Float']>;
  contains?: Maybe<Scalars['Float']>;
  notContains?: Maybe<Scalars['Float']>;
  containsi?: Maybe<Scalars['Float']>;
  notContainsi?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['Float']>>>;
  between?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type Form = {
  __typename?: 'Form';
  documentId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  formSections?: Maybe<Array<Maybe<ComponentComponentsFormSection>>>;
  slug?: Maybe<Scalars['String']>;
  successMessage?: Maybe<Scalars['String']>;
  descriptionSection?: Maybe<ComponentComponentsDescriptionSection>;
  type?: Maybe<Enum_Form_Type>;
  sendButtonText?: Maybe<Scalars['String']>;
  hubspotFormId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations_connection?: Maybe<FormRelationResponseCollection>;
  localizations: Array<Maybe<Form>>;
};


export type FormFormSectionsArgs = {
  filters?: Maybe<ComponentComponentsFormSectionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type FormLocalizations_ConnectionArgs = {
  filters?: Maybe<FormFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type FormLocalizationsArgs = {
  filters?: Maybe<FormFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FormEntityResponseCollection = {
  __typename?: 'FormEntityResponseCollection';
  nodes: Array<Form>;
  pageInfo: Pagination;
};

export type FormFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  title?: Maybe<StringFilterInput>;
  formSections?: Maybe<ComponentComponentsFormSectionFiltersInput>;
  slug?: Maybe<StringFilterInput>;
  successMessage?: Maybe<StringFilterInput>;
  descriptionSection?: Maybe<ComponentComponentsDescriptionSectionFiltersInput>;
  type?: Maybe<StringFilterInput>;
  sendButtonText?: Maybe<StringFilterInput>;
  hubspotFormId?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  locale?: Maybe<StringFilterInput>;
  localizations?: Maybe<FormFiltersInput>;
  and?: Maybe<Array<Maybe<FormFiltersInput>>>;
  or?: Maybe<Array<Maybe<FormFiltersInput>>>;
  not?: Maybe<FormFiltersInput>;
};

export type FormInput = {
  title?: Maybe<Scalars['String']>;
  formSections?: Maybe<Array<Maybe<ComponentComponentsFormSectionInput>>>;
  slug?: Maybe<Scalars['String']>;
  successMessage?: Maybe<Scalars['String']>;
  descriptionSection?: Maybe<ComponentComponentsDescriptionSectionInput>;
  type?: Maybe<Enum_Form_Type>;
  sendButtonText?: Maybe<Scalars['String']>;
  hubspotFormId?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type FormRelationResponseCollection = {
  __typename?: 'FormRelationResponseCollection';
  nodes: Array<Form>;
};

export type GenericMorph = ComponentAcademyItemsList | ComponentAcademyCurriculumList | ComponentAcademyCurriculumItem | ComponentAcademyCards | ComponentComponentsWhereToFind | ComponentComponentsUserTestimony | ComponentComponentsTimeline | ComponentComponentsTextWithSideList | ComponentComponentsTestimonialDetail | ComponentComponentsTechnologies | ComponentComponentsTeamCalculator | ComponentComponentsService | ComponentComponentsServiceItem | ComponentComponentsSection | ComponentComponentsSectionTitleItemList | ComponentComponentsSectionTextColumns | ComponentComponentsSectionTextButtons | ComponentComponentsSectionQuote | ComponentComponentsSectionImageRichText | ComponentComponentsSectionImageRichTextList | ComponentComponentsSectionImageRichTextListItem | ComponentComponentsSectionCards | ComponentComponentsSectionBackgroundImageRichText | ComponentComponentsRichtext | ComponentComponentsQuestion | ComponentComponentsProjectsList | ComponentComponentsNumberSlider | ComponentComponentsMetadata | ComponentComponentsMenuItems | ComponentComponentsItems | ComponentComponentsHubspotMeeting | ComponentComponentsGlassdoor | ComponentComponentsGetInTouch | ComponentComponentsGallery | ComponentComponentsForm | ComponentComponentsFormSection | ComponentComponentsFormSectionWithAnswers | ComponentComponentsFormFields | ComponentComponentsEventList | ComponentComponentsDottedList | ComponentComponentsDottedListItem | ComponentComponentsDevelopmentDetails | ComponentComponentsDescriptionSection | ComponentComponentsContents | ComponentComponentsContent | ComponentComponentsContactForm | ComponentComponentsContactCard | ComponentComponentsComponents | ComponentComponentsCompanyForm | ComponentComponentsCards | ComponentComponentsCardItem | ComponentComponentsCardDisplay | ComponentComponentsButton | ComponentComponentsBudgetForm | ComponentComponentsBlog | ComponentComponentsBanner | ComponentComponentsAvailableJobs | ComponentComponentsAnswer | ComponentComponentsAnswerOption | ComponentComponentsActionLink | UploadFile | I18NLocale | ReviewWorkflowsWorkflow | ReviewWorkflowsWorkflowStage | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser | AboutUs | AcademyAboutUs | AcademyContact | Author | Blog | BlogsPage | Course | Event | FeedbackSubmission | Form | HomePage | Lead | Menu | Page | Project | ProjectsPage | Service | Subscription | TechnologiesPage | Technology | Testimony | WebsiteContact | WizardSubmission;

export type HomePage = {
  __typename?: 'HomePage';
  documentId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  banner?: Maybe<UploadFile>;
  homeDynamic?: Maybe<Array<Maybe<HomePageHomeDynamicDynamicZone>>>;
  metadata?: Maybe<ComponentComponentsMetadata>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations_connection?: Maybe<HomePageRelationResponseCollection>;
  localizations: Array<Maybe<HomePage>>;
};

export type HomePageHomeDynamicDynamicZone = ComponentComponentsSection | ComponentComponentsUserTestimony | ComponentComponentsTechnologies | ComponentComponentsBlog | ComponentComponentsGlassdoor | ComponentComponentsAvailableJobs | ComponentComponentsContactForm | ComponentComponentsCompanyForm | ComponentComponentsHubspotMeeting | ComponentComponentsSectionBackgroundImageRichText | ComponentComponentsSectionImageRichText | ComponentComponentsSectionQuote | ComponentComponentsSectionTextButtons | ComponentComponentsSectionTextColumns | ComponentComponentsSectionCards | ComponentComponentsSectionImageRichTextList | ComponentComponentsSectionTitleItemList | ComponentComponentsEventList | Error;


export type HomePageInput = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  banner?: Maybe<Scalars['ID']>;
  homeDynamic?: Maybe<Array<Scalars['HomePageHomeDynamicDynamicZoneInput']>>;
  metadata?: Maybe<ComponentComponentsMetadataInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type HomePageRelationResponseCollection = {
  __typename?: 'HomePageRelationResponseCollection';
  nodes: Array<HomePage>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  documentId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  nodes: Array<I18NLocale>;
  pageInfo: Pagination;
};

export type I18NLocaleFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  code?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<I18NLocaleFiltersInput>>>;
  or?: Maybe<Array<Maybe<I18NLocaleFiltersInput>>>;
  not?: Maybe<I18NLocaleFiltersInput>;
};

export type IdFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['ID']>>>;
  or?: Maybe<Array<Maybe<Scalars['ID']>>>;
  not?: Maybe<IdFilterInput>;
  eq?: Maybe<Scalars['ID']>;
  eqi?: Maybe<Scalars['ID']>;
  ne?: Maybe<Scalars['ID']>;
  nei?: Maybe<Scalars['ID']>;
  startsWith?: Maybe<Scalars['ID']>;
  endsWith?: Maybe<Scalars['ID']>;
  contains?: Maybe<Scalars['ID']>;
  notContains?: Maybe<Scalars['ID']>;
  containsi?: Maybe<Scalars['ID']>;
  notContainsi?: Maybe<Scalars['ID']>;
  gt?: Maybe<Scalars['ID']>;
  gte?: Maybe<Scalars['ID']>;
  lt?: Maybe<Scalars['ID']>;
  lte?: Maybe<Scalars['ID']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['ID']>>>;
  between?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type IntFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['Int']>>>;
  or?: Maybe<Array<Maybe<Scalars['Int']>>>;
  not?: Maybe<IntFilterInput>;
  eq?: Maybe<Scalars['Int']>;
  eqi?: Maybe<Scalars['Int']>;
  ne?: Maybe<Scalars['Int']>;
  nei?: Maybe<Scalars['Int']>;
  startsWith?: Maybe<Scalars['Int']>;
  endsWith?: Maybe<Scalars['Int']>;
  contains?: Maybe<Scalars['Int']>;
  notContains?: Maybe<Scalars['Int']>;
  containsi?: Maybe<Scalars['Int']>;
  notContainsi?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['Int']>>>;
  between?: Maybe<Array<Maybe<Scalars['Int']>>>;
};


export type JsonFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  or?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  not?: Maybe<JsonFilterInput>;
  eq?: Maybe<Scalars['JSON']>;
  eqi?: Maybe<Scalars['JSON']>;
  ne?: Maybe<Scalars['JSON']>;
  nei?: Maybe<Scalars['JSON']>;
  startsWith?: Maybe<Scalars['JSON']>;
  endsWith?: Maybe<Scalars['JSON']>;
  contains?: Maybe<Scalars['JSON']>;
  notContains?: Maybe<Scalars['JSON']>;
  containsi?: Maybe<Scalars['JSON']>;
  notContainsi?: Maybe<Scalars['JSON']>;
  gt?: Maybe<Scalars['JSON']>;
  gte?: Maybe<Scalars['JSON']>;
  lt?: Maybe<Scalars['JSON']>;
  lte?: Maybe<Scalars['JSON']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  between?: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

export type Lead = {
  __typename?: 'Lead';
  documentId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  newsletter?: Maybe<Scalars['Boolean']>;
  subscriptions_connection?: Maybe<SubscriptionRelationResponseCollection>;
  subscriptions: Array<Maybe<Subscription>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type LeadSubscriptions_ConnectionArgs = {
  filters?: Maybe<SubscriptionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type LeadSubscriptionsArgs = {
  filters?: Maybe<SubscriptionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type LeadEntityResponseCollection = {
  __typename?: 'LeadEntityResponseCollection';
  nodes: Array<Lead>;
  pageInfo: Pagination;
};

export type LeadFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  email?: Maybe<StringFilterInput>;
  phone?: Maybe<StringFilterInput>;
  newsletter?: Maybe<BooleanFilterInput>;
  subscriptions?: Maybe<SubscriptionFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<LeadFiltersInput>>>;
  or?: Maybe<Array<Maybe<LeadFiltersInput>>>;
  not?: Maybe<LeadFiltersInput>;
};

export type LeadInput = {
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  newsletter?: Maybe<Scalars['Boolean']>;
  subscriptions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type Menu = {
  __typename?: 'Menu';
  documentId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  direction?: Maybe<Enum_Menu_Direction>;
  items?: Maybe<Array<Maybe<ComponentComponentsMenuItems>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations_connection?: Maybe<MenuRelationResponseCollection>;
  localizations: Array<Maybe<Menu>>;
};


export type MenuItemsArgs = {
  filters?: Maybe<ComponentComponentsMenuItemsFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MenuLocalizations_ConnectionArgs = {
  filters?: Maybe<MenuFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MenuLocalizationsArgs = {
  filters?: Maybe<MenuFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MenuEntityResponseCollection = {
  __typename?: 'MenuEntityResponseCollection';
  nodes: Array<Menu>;
  pageInfo: Pagination;
};

export type MenuFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  title?: Maybe<StringFilterInput>;
  direction?: Maybe<StringFilterInput>;
  items?: Maybe<ComponentComponentsMenuItemsFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  locale?: Maybe<StringFilterInput>;
  localizations?: Maybe<MenuFiltersInput>;
  and?: Maybe<Array<Maybe<MenuFiltersInput>>>;
  or?: Maybe<Array<Maybe<MenuFiltersInput>>>;
  not?: Maybe<MenuFiltersInput>;
};

export type MenuInput = {
  title?: Maybe<Scalars['String']>;
  direction?: Maybe<Enum_Menu_Direction>;
  items?: Maybe<Array<Maybe<ComponentComponentsMenuItemsInput>>>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type MenuRelationResponseCollection = {
  __typename?: 'MenuRelationResponseCollection';
  nodes: Array<Menu>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  updateReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  deleteReviewWorkflowsWorkflow?: Maybe<DeleteMutationResponse>;
  createReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updateReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  deleteReviewWorkflowsWorkflowStage?: Maybe<DeleteMutationResponse>;
  updateAboutUs?: Maybe<AboutUs>;
  deleteAboutUs?: Maybe<DeleteMutationResponse>;
  updateAcademyAboutUs?: Maybe<AcademyAboutUs>;
  deleteAcademyAboutUs?: Maybe<DeleteMutationResponse>;
  createAcademyContact?: Maybe<AcademyContact>;
  updateAcademyContact?: Maybe<AcademyContact>;
  deleteAcademyContact?: Maybe<DeleteMutationResponse>;
  createAuthor?: Maybe<Author>;
  updateAuthor?: Maybe<Author>;
  deleteAuthor?: Maybe<DeleteMutationResponse>;
  createBlog?: Maybe<Blog>;
  updateBlog?: Maybe<Blog>;
  deleteBlog?: Maybe<DeleteMutationResponse>;
  updateBlogsPage?: Maybe<BlogsPage>;
  deleteBlogsPage?: Maybe<DeleteMutationResponse>;
  createCourse?: Maybe<Course>;
  updateCourse?: Maybe<Course>;
  deleteCourse?: Maybe<DeleteMutationResponse>;
  createEvent?: Maybe<Event>;
  updateEvent?: Maybe<Event>;
  deleteEvent?: Maybe<DeleteMutationResponse>;
  createFeedbackSubmission?: Maybe<FeedbackSubmission>;
  updateFeedbackSubmission?: Maybe<FeedbackSubmission>;
  deleteFeedbackSubmission?: Maybe<DeleteMutationResponse>;
  createForm?: Maybe<Form>;
  updateForm?: Maybe<Form>;
  deleteForm?: Maybe<DeleteMutationResponse>;
  updateHomePage?: Maybe<HomePage>;
  deleteHomePage?: Maybe<DeleteMutationResponse>;
  createLead?: Maybe<Lead>;
  updateLead?: Maybe<Lead>;
  deleteLead?: Maybe<DeleteMutationResponse>;
  createMenu?: Maybe<Menu>;
  updateMenu?: Maybe<Menu>;
  deleteMenu?: Maybe<DeleteMutationResponse>;
  createPage?: Maybe<Page>;
  updatePage?: Maybe<Page>;
  deletePage?: Maybe<DeleteMutationResponse>;
  createProject?: Maybe<Project>;
  updateProject?: Maybe<Project>;
  deleteProject?: Maybe<DeleteMutationResponse>;
  updateProjectsPage?: Maybe<ProjectsPage>;
  deleteProjectsPage?: Maybe<DeleteMutationResponse>;
  updateService?: Maybe<Service>;
  deleteService?: Maybe<DeleteMutationResponse>;
  createSubscription?: Maybe<Subscription>;
  updateSubscription?: Maybe<Subscription>;
  deleteSubscription?: Maybe<DeleteMutationResponse>;
  updateTechnologiesPage?: Maybe<TechnologiesPage>;
  deleteTechnologiesPage?: Maybe<DeleteMutationResponse>;
  createTechnology?: Maybe<Technology>;
  updateTechnology?: Maybe<Technology>;
  deleteTechnology?: Maybe<DeleteMutationResponse>;
  createTestimony?: Maybe<Testimony>;
  updateTestimony?: Maybe<Testimony>;
  deleteTestimony?: Maybe<DeleteMutationResponse>;
  createWebsiteContact?: Maybe<WebsiteContact>;
  updateWebsiteContact?: Maybe<WebsiteContact>;
  deleteWebsiteContact?: Maybe<DeleteMutationResponse>;
  createWizardSubmission?: Maybe<WizardSubmission>;
  updateWizardSubmission?: Maybe<WizardSubmission>;
  deleteWizardSubmission?: Maybe<DeleteMutationResponse>;
  updateUploadFile: UploadFile;
  deleteUploadFile?: Maybe<UploadFile>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  login: UsersPermissionsLoginPayload;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  createContactAndSendEmail: AcademyContact;
  attachCourseToEmail?: Maybe<Subscription>;
  createContactAndSendEmailWebsite: WebsiteContact;
  updateCurrentSubscription: Subscription;
};


export type MutationCreateReviewWorkflowsWorkflowArgs = {
  status?: Maybe<PublicationStatus>;
  data: ReviewWorkflowsWorkflowInput;
};


export type MutationUpdateReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: ReviewWorkflowsWorkflowInput;
};


export type MutationDeleteReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateReviewWorkflowsWorkflowStageArgs = {
  status?: Maybe<PublicationStatus>;
  data: ReviewWorkflowsWorkflowStageInput;
};


export type MutationUpdateReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: ReviewWorkflowsWorkflowStageInput;
};


export type MutationDeleteReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID'];
};


export type MutationUpdateAboutUsArgs = {
  status?: Maybe<PublicationStatus>;
  data: AboutUsInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteAboutUsArgs = {
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateAcademyAboutUsArgs = {
  status?: Maybe<PublicationStatus>;
  data: AcademyAboutUsInput;
};


export type MutationCreateAcademyContactArgs = {
  status?: Maybe<PublicationStatus>;
  data: AcademyContactInput;
};


export type MutationUpdateAcademyContactArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: AcademyContactInput;
};


export type MutationDeleteAcademyContactArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateAuthorArgs = {
  status?: Maybe<PublicationStatus>;
  data: AuthorInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateAuthorArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: AuthorInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteAuthorArgs = {
  documentId: Scalars['ID'];
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateBlogArgs = {
  status?: Maybe<PublicationStatus>;
  data: BlogInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateBlogArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: BlogInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteBlogArgs = {
  documentId: Scalars['ID'];
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateBlogsPageArgs = {
  status?: Maybe<PublicationStatus>;
  data: BlogsPageInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteBlogsPageArgs = {
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateCourseArgs = {
  status?: Maybe<PublicationStatus>;
  data: CourseInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateCourseArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: CourseInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteCourseArgs = {
  documentId: Scalars['ID'];
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateEventArgs = {
  status?: Maybe<PublicationStatus>;
  data: EventInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateEventArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: EventInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteEventArgs = {
  documentId: Scalars['ID'];
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateFeedbackSubmissionArgs = {
  status?: Maybe<PublicationStatus>;
  data: FeedbackSubmissionInput;
};


export type MutationUpdateFeedbackSubmissionArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: FeedbackSubmissionInput;
};


export type MutationDeleteFeedbackSubmissionArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateFormArgs = {
  status?: Maybe<PublicationStatus>;
  data: FormInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateFormArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: FormInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteFormArgs = {
  documentId: Scalars['ID'];
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateHomePageArgs = {
  status?: Maybe<PublicationStatus>;
  data: HomePageInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteHomePageArgs = {
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateLeadArgs = {
  status?: Maybe<PublicationStatus>;
  data: LeadInput;
};


export type MutationUpdateLeadArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: LeadInput;
};


export type MutationDeleteLeadArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateMenuArgs = {
  status?: Maybe<PublicationStatus>;
  data: MenuInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateMenuArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: MenuInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteMenuArgs = {
  documentId: Scalars['ID'];
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreatePageArgs = {
  status?: Maybe<PublicationStatus>;
  data: PageInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdatePageArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: PageInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeletePageArgs = {
  documentId: Scalars['ID'];
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateProjectArgs = {
  status?: Maybe<PublicationStatus>;
  data: ProjectInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateProjectArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: ProjectInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteProjectArgs = {
  documentId: Scalars['ID'];
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateProjectsPageArgs = {
  status?: Maybe<PublicationStatus>;
  data: ProjectsPageInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteProjectsPageArgs = {
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateServiceArgs = {
  status?: Maybe<PublicationStatus>;
  data: ServiceInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteServiceArgs = {
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateSubscriptionArgs = {
  status?: Maybe<PublicationStatus>;
  data: SubscriptionInput;
};


export type MutationUpdateSubscriptionArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: SubscriptionInput;
};


export type MutationDeleteSubscriptionArgs = {
  documentId: Scalars['ID'];
};


export type MutationUpdateTechnologiesPageArgs = {
  status?: Maybe<PublicationStatus>;
  data: TechnologiesPageInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteTechnologiesPageArgs = {
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateTechnologyArgs = {
  status?: Maybe<PublicationStatus>;
  data: TechnologyInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateTechnologyArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: TechnologyInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteTechnologyArgs = {
  documentId: Scalars['ID'];
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateTestimonyArgs = {
  status?: Maybe<PublicationStatus>;
  data: TestimonyInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationUpdateTestimonyArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: TestimonyInput;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationDeleteTestimonyArgs = {
  documentId: Scalars['ID'];
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type MutationCreateWebsiteContactArgs = {
  status?: Maybe<PublicationStatus>;
  data: WebsiteContactInput;
};


export type MutationUpdateWebsiteContactArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: WebsiteContactInput;
};


export type MutationDeleteWebsiteContactArgs = {
  documentId: Scalars['ID'];
};


export type MutationCreateWizardSubmissionArgs = {
  status?: Maybe<PublicationStatus>;
  data: WizardSubmissionInput;
};


export type MutationUpdateWizardSubmissionArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  data: WizardSubmissionInput;
};


export type MutationDeleteWizardSubmissionArgs = {
  documentId: Scalars['ID'];
};


export type MutationUpdateUploadFileArgs = {
  id: Scalars['ID'];
  info?: Maybe<FileInfoInput>;
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID'];
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  id: Scalars['ID'];
  data: UsersPermissionsRoleInput;
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID'];
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationUpdateUsersPermissionsUserArgs = {
  id: Scalars['ID'];
  data: UsersPermissionsUserInput;
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  code: Scalars['String'];
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};


export type MutationCreateContactAndSendEmailArgs = {
  name: Scalars['String'];
  phone: Scalars['String'];
  email: Scalars['String'];
  subject: Scalars['String'];
  message: Scalars['String'];
};


export type MutationAttachCourseToEmailArgs = {
  email: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  courseSlug: Scalars['String'];
  courseTitle: Scalars['String'];
  newsletter: Scalars['Boolean'];
  status: Scalars['String'];
};


export type MutationCreateContactAndSendEmailWebsiteArgs = {
  email: Scalars['String'];
  name: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  formTitle?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  wizardId?: Maybe<Scalars['String']>;
  bufferPdf?: Maybe<Scalars['String']>;
};


export type MutationUpdateCurrentSubscriptionArgs = {
  leadDocumentId: Scalars['String'];
  courseDocumentId: Scalars['String'];
  status: Scalars['String'];
};

export type Page = {
  __typename?: 'Page';
  documentId: Scalars['ID'];
  pageDynamic?: Maybe<Array<Maybe<PagePageDynamicDynamicZone>>>;
  metadata?: Maybe<ComponentComponentsMetadata>;
  slug?: Maybe<Scalars['String']>;
  isLandingPage?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations_connection?: Maybe<PageRelationResponseCollection>;
  localizations: Array<Maybe<Page>>;
};


export type PageLocalizations_ConnectionArgs = {
  filters?: Maybe<PageFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type PageLocalizationsArgs = {
  filters?: Maybe<PageFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PageEntityResponseCollection = {
  __typename?: 'PageEntityResponseCollection';
  nodes: Array<Page>;
  pageInfo: Pagination;
};

export type PageFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  metadata?: Maybe<ComponentComponentsMetadataFiltersInput>;
  slug?: Maybe<StringFilterInput>;
  isLandingPage?: Maybe<BooleanFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  locale?: Maybe<StringFilterInput>;
  localizations?: Maybe<PageFiltersInput>;
  and?: Maybe<Array<Maybe<PageFiltersInput>>>;
  or?: Maybe<Array<Maybe<PageFiltersInput>>>;
  not?: Maybe<PageFiltersInput>;
};

export type PageInput = {
  pageDynamic?: Maybe<Array<Scalars['PagePageDynamicDynamicZoneInput']>>;
  metadata?: Maybe<ComponentComponentsMetadataInput>;
  slug?: Maybe<Scalars['String']>;
  isLandingPage?: Maybe<Scalars['Boolean']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type PagePageDynamicDynamicZone = ComponentComponentsRichtext | ComponentComponentsTechnologies | ComponentComponentsDottedList | ComponentComponentsSection | ComponentComponentsTextWithSideList | ComponentComponentsGallery | ComponentComponentsUserTestimony | ComponentComponentsBanner | ComponentComponentsGlassdoor | ComponentComponentsAvailableJobs | ComponentComponentsTeamCalculator | ComponentComponentsBudgetForm | ComponentComponentsContactForm | ComponentComponentsContactCard | ComponentComponentsProjectsList | ComponentComponentsCompanyForm | ComponentComponentsSectionImageRichText | ComponentComponentsHubspotMeeting | ComponentComponentsSectionBackgroundImageRichText | ComponentComponentsSectionQuote | ComponentComponentsSectionTextButtons | ComponentComponentsSectionCards | ComponentComponentsSectionTextColumns | ComponentComponentsSectionTitleItemList | ComponentComponentsSectionImageRichTextList | ComponentComponentsEventList | Error;


export type PageRelationResponseCollection = {
  __typename?: 'PageRelationResponseCollection';
  nodes: Array<Page>;
};

export type Pagination = {
  __typename?: 'Pagination';
  total: Scalars['Int'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  pageCount: Scalars['Int'];
};

export type PaginationArg = {
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type Project = {
  __typename?: 'Project';
  documentId: Scalars['ID'];
  type?: Maybe<Enum_Project_Type>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  clientLocation?: Maybe<Scalars['String']>;
  thumbnailImage?: Maybe<UploadFile>;
  metadata?: Maybe<ComponentComponentsMetadata>;
  projectsDynamic?: Maybe<Array<Maybe<ProjectProjectsDynamicDynamicZone>>>;
  slug?: Maybe<Scalars['String']>;
  publicationDate: Scalars['Date'];
  image?: Maybe<UploadFile>;
  featured?: Maybe<Scalars['Boolean']>;
  featuredDescription?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations_connection?: Maybe<ProjectRelationResponseCollection>;
  localizations: Array<Maybe<Project>>;
};


export type ProjectLocalizations_ConnectionArgs = {
  filters?: Maybe<ProjectFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ProjectLocalizationsArgs = {
  filters?: Maybe<ProjectFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProjectEntityResponseCollection = {
  __typename?: 'ProjectEntityResponseCollection';
  nodes: Array<Project>;
  pageInfo: Pagination;
};

export type ProjectFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  type?: Maybe<StringFilterInput>;
  title?: Maybe<StringFilterInput>;
  description?: Maybe<StringFilterInput>;
  companyName?: Maybe<StringFilterInput>;
  clientLocation?: Maybe<StringFilterInput>;
  metadata?: Maybe<ComponentComponentsMetadataFiltersInput>;
  slug?: Maybe<StringFilterInput>;
  publicationDate?: Maybe<DateFilterInput>;
  featured?: Maybe<BooleanFilterInput>;
  featuredDescription?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  locale?: Maybe<StringFilterInput>;
  localizations?: Maybe<ProjectFiltersInput>;
  and?: Maybe<Array<Maybe<ProjectFiltersInput>>>;
  or?: Maybe<Array<Maybe<ProjectFiltersInput>>>;
  not?: Maybe<ProjectFiltersInput>;
};

export type ProjectInput = {
  type?: Maybe<Enum_Project_Type>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  clientLocation?: Maybe<Scalars['String']>;
  thumbnailImage?: Maybe<Scalars['ID']>;
  metadata?: Maybe<ComponentComponentsMetadataInput>;
  projectsDynamic?: Maybe<Array<Scalars['ProjectProjectsDynamicDynamicZoneInput']>>;
  slug?: Maybe<Scalars['String']>;
  publicationDate?: Maybe<Scalars['Date']>;
  image?: Maybe<Scalars['ID']>;
  featured?: Maybe<Scalars['Boolean']>;
  featuredDescription?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type ProjectProjectsDynamicDynamicZone = ComponentComponentsRichtext | ComponentComponentsTechnologies | ComponentComponentsUserTestimony | ComponentComponentsDevelopmentDetails | ComponentComponentsGallery | ComponentComponentsTestimonialDetail | ComponentComponentsCompanyForm | ComponentComponentsContactForm | ComponentComponentsHubspotMeeting | ComponentComponentsSectionBackgroundImageRichText | ComponentComponentsSectionCards | ComponentComponentsSectionImageRichText | ComponentComponentsSectionQuote | ComponentComponentsSectionTextButtons | ComponentComponentsSectionTextColumns | ComponentComponentsSectionImageRichTextList | ComponentComponentsEventList | Error;


export type ProjectRelationResponseCollection = {
  __typename?: 'ProjectRelationResponseCollection';
  nodes: Array<Project>;
};

export type ProjectsPage = {
  __typename?: 'ProjectsPage';
  documentId: Scalars['ID'];
  metadata?: Maybe<ComponentComponentsMetadata>;
  banner?: Maybe<UploadFile>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations_connection?: Maybe<ProjectsPageRelationResponseCollection>;
  localizations: Array<Maybe<ProjectsPage>>;
};

export type ProjectsPageInput = {
  metadata?: Maybe<ComponentComponentsMetadataInput>;
  banner?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type ProjectsPageRelationResponseCollection = {
  __typename?: 'ProjectsPageRelationResponseCollection';
  nodes: Array<ProjectsPage>;
};

export enum PublicationStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type Query = {
  __typename?: 'Query';
  uploadFile?: Maybe<UploadFile>;
  uploadFiles_connection?: Maybe<UploadFileEntityResponseCollection>;
  uploadFiles: Array<Maybe<UploadFile>>;
  i18NLocale?: Maybe<I18NLocale>;
  i18NLocales_connection?: Maybe<I18NLocaleEntityResponseCollection>;
  i18NLocales: Array<Maybe<I18NLocale>>;
  reviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  reviewWorkflowsWorkflows_connection?: Maybe<ReviewWorkflowsWorkflowEntityResponseCollection>;
  reviewWorkflowsWorkflows: Array<Maybe<ReviewWorkflowsWorkflow>>;
  reviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  reviewWorkflowsWorkflowStages_connection?: Maybe<ReviewWorkflowsWorkflowStageEntityResponseCollection>;
  reviewWorkflowsWorkflowStages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  usersPermissionsRole?: Maybe<UsersPermissionsRole>;
  usersPermissionsRoles_connection?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsRoles: Array<Maybe<UsersPermissionsRole>>;
  usersPermissionsUser?: Maybe<UsersPermissionsUser>;
  usersPermissionsUsers_connection?: Maybe<UsersPermissionsUserEntityResponseCollection>;
  usersPermissionsUsers: Array<Maybe<UsersPermissionsUser>>;
  aboutUs?: Maybe<AboutUs>;
  academyAboutUs?: Maybe<AcademyAboutUs>;
  academyContact?: Maybe<AcademyContact>;
  academyContacts_connection?: Maybe<AcademyContactEntityResponseCollection>;
  academyContacts: Array<Maybe<AcademyContact>>;
  author?: Maybe<Author>;
  authors_connection?: Maybe<AuthorEntityResponseCollection>;
  authors: Array<Maybe<Author>>;
  blog?: Maybe<Blog>;
  blogs_connection?: Maybe<BlogEntityResponseCollection>;
  blogs: Array<Maybe<Blog>>;
  blogsPage?: Maybe<BlogsPage>;
  course?: Maybe<Course>;
  courses_connection?: Maybe<CourseEntityResponseCollection>;
  courses: Array<Maybe<Course>>;
  event?: Maybe<Event>;
  events_connection?: Maybe<EventEntityResponseCollection>;
  events: Array<Maybe<Event>>;
  feedbackSubmission?: Maybe<FeedbackSubmission>;
  feedbackSubmissions_connection?: Maybe<FeedbackSubmissionEntityResponseCollection>;
  feedbackSubmissions: Array<Maybe<FeedbackSubmission>>;
  form?: Maybe<Form>;
  forms_connection?: Maybe<FormEntityResponseCollection>;
  forms: Array<Maybe<Form>>;
  homePage?: Maybe<HomePage>;
  lead?: Maybe<Lead>;
  leads_connection?: Maybe<LeadEntityResponseCollection>;
  leads: Array<Maybe<Lead>>;
  menu?: Maybe<Menu>;
  menus_connection?: Maybe<MenuEntityResponseCollection>;
  menus: Array<Maybe<Menu>>;
  page?: Maybe<Page>;
  pages_connection?: Maybe<PageEntityResponseCollection>;
  pages: Array<Maybe<Page>>;
  project?: Maybe<Project>;
  projects_connection?: Maybe<ProjectEntityResponseCollection>;
  projects: Array<Maybe<Project>>;
  projectsPage?: Maybe<ProjectsPage>;
  service?: Maybe<Service>;
  subscription?: Maybe<Subscription>;
  subscriptions_connection?: Maybe<SubscriptionEntityResponseCollection>;
  subscriptions: Array<Maybe<Subscription>>;
  technologiesPage?: Maybe<TechnologiesPage>;
  technology?: Maybe<Technology>;
  technologies_connection?: Maybe<TechnologyEntityResponseCollection>;
  technologies: Array<Maybe<Technology>>;
  testimony?: Maybe<Testimony>;
  testimonies_connection?: Maybe<TestimonyEntityResponseCollection>;
  testimonies: Array<Maybe<Testimony>>;
  websiteContact?: Maybe<WebsiteContact>;
  websiteContacts_connection?: Maybe<WebsiteContactEntityResponseCollection>;
  websiteContacts: Array<Maybe<WebsiteContact>>;
  wizardSubmission?: Maybe<WizardSubmission>;
  wizardSubmissions_connection?: Maybe<WizardSubmissionEntityResponseCollection>;
  wizardSubmissions: Array<Maybe<WizardSubmission>>;
  me?: Maybe<UsersPermissionsMe>;
  projectsFilter: Array<Maybe<SearchData>>;
  blogsFilter: Array<Maybe<SearchData>>;
  technologiesFilter: Array<Maybe<SearchData>>;
  pagesFilter: Array<Maybe<SearchData>>;
};


export type QueryUploadFileArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryUploadFiles_ConnectionArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryUploadFilesArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryI18NLocaleArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryI18NLocales_ConnectionArgs = {
  filters?: Maybe<I18NLocaleFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryI18NLocalesArgs = {
  filters?: Maybe<I18NLocaleFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflows_ConnectionArgs = {
  filters?: Maybe<ReviewWorkflowsWorkflowFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowsArgs = {
  filters?: Maybe<ReviewWorkflowsWorkflowFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: Maybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStagesArgs = {
  filters?: Maybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryUsersPermissionsRoleArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryUsersPermissionsRoles_ConnectionArgs = {
  filters?: Maybe<UsersPermissionsRoleFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: Maybe<UsersPermissionsRoleFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryUsersPermissionsUserArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryUsersPermissionsUsers_ConnectionArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryAboutUsArgs = {
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryAcademyAboutUsArgs = {
  status?: Maybe<PublicationStatus>;
};


export type QueryAcademyContactArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryAcademyContacts_ConnectionArgs = {
  filters?: Maybe<AcademyContactFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryAcademyContactsArgs = {
  filters?: Maybe<AcademyContactFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryAuthorArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryAuthors_ConnectionArgs = {
  filters?: Maybe<AuthorFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryAuthorsArgs = {
  filters?: Maybe<AuthorFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryBlogArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryBlogs_ConnectionArgs = {
  filters?: Maybe<BlogFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryBlogsArgs = {
  filters?: Maybe<BlogFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryBlogsPageArgs = {
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryCourseArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryCourses_ConnectionArgs = {
  filters?: Maybe<CourseFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryCoursesArgs = {
  filters?: Maybe<CourseFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryEventArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryEvents_ConnectionArgs = {
  filters?: Maybe<EventFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryEventsArgs = {
  filters?: Maybe<EventFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryFeedbackSubmissionArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryFeedbackSubmissions_ConnectionArgs = {
  filters?: Maybe<FeedbackSubmissionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryFeedbackSubmissionsArgs = {
  filters?: Maybe<FeedbackSubmissionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryFormArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryForms_ConnectionArgs = {
  filters?: Maybe<FormFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryFormsArgs = {
  filters?: Maybe<FormFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryHomePageArgs = {
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryLeadArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryLeads_ConnectionArgs = {
  filters?: Maybe<LeadFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryLeadsArgs = {
  filters?: Maybe<LeadFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryMenuArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryMenus_ConnectionArgs = {
  filters?: Maybe<MenuFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryMenusArgs = {
  filters?: Maybe<MenuFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryPageArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryPages_ConnectionArgs = {
  filters?: Maybe<PageFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryPagesArgs = {
  filters?: Maybe<PageFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryProjectArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryProjects_ConnectionArgs = {
  filters?: Maybe<ProjectFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryProjectsArgs = {
  filters?: Maybe<ProjectFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryProjectsPageArgs = {
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryServiceArgs = {
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QuerySubscriptionArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QuerySubscriptions_ConnectionArgs = {
  filters?: Maybe<SubscriptionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QuerySubscriptionsArgs = {
  filters?: Maybe<SubscriptionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryTechnologiesPageArgs = {
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryTechnologyArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryTechnologies_ConnectionArgs = {
  filters?: Maybe<TechnologyFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryTechnologiesArgs = {
  filters?: Maybe<TechnologyFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryTestimonyArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryTestimonies_ConnectionArgs = {
  filters?: Maybe<TestimonyFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryTestimoniesArgs = {
  filters?: Maybe<TestimonyFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
  locale?: Maybe<Scalars['I18NLocaleCode']>;
};


export type QueryWebsiteContactArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryWebsiteContacts_ConnectionArgs = {
  filters?: Maybe<WebsiteContactFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryWebsiteContactsArgs = {
  filters?: Maybe<WebsiteContactFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryWizardSubmissionArgs = {
  documentId: Scalars['ID'];
  status?: Maybe<PublicationStatus>;
};


export type QueryWizardSubmissions_ConnectionArgs = {
  filters?: Maybe<WizardSubmissionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryWizardSubmissionsArgs = {
  filters?: Maybe<WizardSubmissionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PublicationStatus>;
};


export type QueryProjectsFilterArgs = {
  query: Scalars['String'];
  locale: Scalars['I18NLocaleCode'];
};


export type QueryBlogsFilterArgs = {
  query: Scalars['String'];
  locale: Scalars['I18NLocaleCode'];
};


export type QueryTechnologiesFilterArgs = {
  query: Scalars['String'];
  locale: Scalars['I18NLocaleCode'];
};


export type QueryPagesFilterArgs = {
  query: Scalars['String'];
  locale: Scalars['I18NLocaleCode'];
};

export type ReviewWorkflowsWorkflow = {
  __typename?: 'ReviewWorkflowsWorkflow';
  documentId: Scalars['ID'];
  name: Scalars['String'];
  stages_connection?: Maybe<ReviewWorkflowsWorkflowStageRelationResponseCollection>;
  stages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  stageRequiredToPublish?: Maybe<ReviewWorkflowsWorkflowStage>;
  contentTypes: Scalars['JSON'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type ReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: Maybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ReviewWorkflowsWorkflowStagesArgs = {
  filters?: Maybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ReviewWorkflowsWorkflowEntityResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowEntityResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflow>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  stages?: Maybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  stageRequiredToPublish?: Maybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  contentTypes?: Maybe<JsonFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  or?: Maybe<Array<Maybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  not?: Maybe<ReviewWorkflowsWorkflowFiltersInput>;
};

export type ReviewWorkflowsWorkflowInput = {
  name?: Maybe<Scalars['String']>;
  stages?: Maybe<Array<Maybe<Scalars['ID']>>>;
  stageRequiredToPublish?: Maybe<Scalars['ID']>;
  contentTypes?: Maybe<Scalars['JSON']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewWorkflowsWorkflowStage = {
  __typename?: 'ReviewWorkflowsWorkflowStage';
  documentId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  workflow?: Maybe<ReviewWorkflowsWorkflow>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewWorkflowsWorkflowStageEntityResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowStageEntityResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflowStage>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowStageFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  color?: Maybe<StringFilterInput>;
  workflow?: Maybe<ReviewWorkflowsWorkflowFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  or?: Maybe<Array<Maybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  not?: Maybe<ReviewWorkflowsWorkflowStageFiltersInput>;
};

export type ReviewWorkflowsWorkflowStageInput = {
  name?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  workflow?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewWorkflowsWorkflowStageRelationResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowStageRelationResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflowStage>;
};

export type SearchData = {
  __typename?: 'SearchData';
  documentId: Scalars['String'];
  slug: Scalars['String'];
  type: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type Service = {
  __typename?: 'Service';
  documentId: Scalars['ID'];
  title: Scalars['String'];
  description: Scalars['String'];
  banner?: Maybe<UploadFile>;
  serviceDynamic?: Maybe<Array<Maybe<ServiceServiceDynamicDynamicZone>>>;
  slug?: Maybe<Scalars['String']>;
  background?: Maybe<Enum_Service_Background>;
  metadata?: Maybe<ComponentComponentsMetadata>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations_connection?: Maybe<ServiceRelationResponseCollection>;
  localizations: Array<Maybe<Service>>;
};

export type ServiceInput = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  banner?: Maybe<Scalars['ID']>;
  serviceDynamic?: Maybe<Array<Scalars['ServiceServiceDynamicDynamicZoneInput']>>;
  slug?: Maybe<Scalars['String']>;
  background?: Maybe<Enum_Service_Background>;
  metadata?: Maybe<ComponentComponentsMetadataInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceRelationResponseCollection = {
  __typename?: 'ServiceRelationResponseCollection';
  nodes: Array<Service>;
};

export type ServiceServiceDynamicDynamicZone = ComponentComponentsTextWithSideList | ComponentComponentsRichtext | ComponentComponentsGetInTouch | ComponentComponentsTechnologies | ComponentComponentsCompanyForm | ComponentComponentsContactForm | ComponentComponentsHubspotMeeting | ComponentComponentsSectionBackgroundImageRichText | ComponentComponentsSectionImageRichText | ComponentComponentsSectionQuote | ComponentComponentsSectionTextButtons | ComponentComponentsSectionTextColumns | ComponentComponentsSectionCards | ComponentComponentsSectionImageRichTextList | ComponentComponentsEventList | Error;


export type StringFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['String']>>>;
  or?: Maybe<Array<Maybe<Scalars['String']>>>;
  not?: Maybe<StringFilterInput>;
  eq?: Maybe<Scalars['String']>;
  eqi?: Maybe<Scalars['String']>;
  ne?: Maybe<Scalars['String']>;
  nei?: Maybe<Scalars['String']>;
  startsWith?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  contains?: Maybe<Scalars['String']>;
  notContains?: Maybe<Scalars['String']>;
  containsi?: Maybe<Scalars['String']>;
  notContainsi?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['String']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  between?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Subscription = {
  __typename?: 'Subscription';
  documentId: Scalars['ID'];
  subscriptionStatus?: Maybe<Enum_Subscription_Subscriptionstatus>;
  title?: Maybe<Scalars['String']>;
  course?: Maybe<Course>;
  lead?: Maybe<Lead>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type SubscriptionEntityResponseCollection = {
  __typename?: 'SubscriptionEntityResponseCollection';
  nodes: Array<Subscription>;
  pageInfo: Pagination;
};

export type SubscriptionFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  subscriptionStatus?: Maybe<StringFilterInput>;
  title?: Maybe<StringFilterInput>;
  course?: Maybe<CourseFiltersInput>;
  lead?: Maybe<LeadFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<SubscriptionFiltersInput>>>;
  or?: Maybe<Array<Maybe<SubscriptionFiltersInput>>>;
  not?: Maybe<SubscriptionFiltersInput>;
};

export type SubscriptionInput = {
  subscriptionStatus?: Maybe<Enum_Subscription_Subscriptionstatus>;
  title?: Maybe<Scalars['String']>;
  course?: Maybe<Scalars['ID']>;
  lead?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type SubscriptionRelationResponseCollection = {
  __typename?: 'SubscriptionRelationResponseCollection';
  nodes: Array<Subscription>;
};

export type TechnologiesPage = {
  __typename?: 'TechnologiesPage';
  documentId: Scalars['ID'];
  metadata?: Maybe<ComponentComponentsMetadata>;
  banner?: Maybe<UploadFile>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations_connection?: Maybe<TechnologiesPageRelationResponseCollection>;
  localizations: Array<Maybe<TechnologiesPage>>;
};

export type TechnologiesPageInput = {
  metadata?: Maybe<ComponentComponentsMetadataInput>;
  banner?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type TechnologiesPageRelationResponseCollection = {
  __typename?: 'TechnologiesPageRelationResponseCollection';
  nodes: Array<TechnologiesPage>;
};

export type Technology = {
  __typename?: 'Technology';
  documentId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  logo?: Maybe<UploadFile>;
  featured?: Maybe<Scalars['Boolean']>;
  body?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  priority?: Maybe<Enum_Technology_Priority>;
  type?: Maybe<Enum_Technology_Type>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations_connection?: Maybe<TechnologyRelationResponseCollection>;
  localizations: Array<Maybe<Technology>>;
};


export type TechnologyLocalizations_ConnectionArgs = {
  filters?: Maybe<TechnologyFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type TechnologyLocalizationsArgs = {
  filters?: Maybe<TechnologyFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type TechnologyEntityResponseCollection = {
  __typename?: 'TechnologyEntityResponseCollection';
  nodes: Array<Technology>;
  pageInfo: Pagination;
};

export type TechnologyFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  title?: Maybe<StringFilterInput>;
  featured?: Maybe<BooleanFilterInput>;
  body?: Maybe<StringFilterInput>;
  slug?: Maybe<StringFilterInput>;
  priority?: Maybe<StringFilterInput>;
  type?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  locale?: Maybe<StringFilterInput>;
  localizations?: Maybe<TechnologyFiltersInput>;
  and?: Maybe<Array<Maybe<TechnologyFiltersInput>>>;
  or?: Maybe<Array<Maybe<TechnologyFiltersInput>>>;
  not?: Maybe<TechnologyFiltersInput>;
};

export type TechnologyInput = {
  title?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['ID']>;
  featured?: Maybe<Scalars['Boolean']>;
  body?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  priority?: Maybe<Enum_Technology_Priority>;
  type?: Maybe<Enum_Technology_Type>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type TechnologyRelationResponseCollection = {
  __typename?: 'TechnologyRelationResponseCollection';
  nodes: Array<Technology>;
};

export type Testimony = {
  __typename?: 'Testimony';
  documentId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  occupation?: Maybe<Scalars['String']>;
  image?: Maybe<UploadFile>;
  companyName?: Maybe<Scalars['String']>;
  featured?: Maybe<Scalars['Boolean']>;
  aboutFeatured?: Maybe<Scalars['Boolean']>;
  testimony?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Testimony_Type>;
  clientCountry?: Maybe<Enum_Testimony_Clientcountry>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations_connection?: Maybe<TestimonyRelationResponseCollection>;
  localizations: Array<Maybe<Testimony>>;
};


export type TestimonyLocalizations_ConnectionArgs = {
  filters?: Maybe<TestimonyFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type TestimonyLocalizationsArgs = {
  filters?: Maybe<TestimonyFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type TestimonyEntityResponseCollection = {
  __typename?: 'TestimonyEntityResponseCollection';
  nodes: Array<Testimony>;
  pageInfo: Pagination;
};

export type TestimonyFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  occupation?: Maybe<StringFilterInput>;
  companyName?: Maybe<StringFilterInput>;
  featured?: Maybe<BooleanFilterInput>;
  aboutFeatured?: Maybe<BooleanFilterInput>;
  testimony?: Maybe<StringFilterInput>;
  type?: Maybe<StringFilterInput>;
  clientCountry?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  locale?: Maybe<StringFilterInput>;
  localizations?: Maybe<TestimonyFiltersInput>;
  and?: Maybe<Array<Maybe<TestimonyFiltersInput>>>;
  or?: Maybe<Array<Maybe<TestimonyFiltersInput>>>;
  not?: Maybe<TestimonyFiltersInput>;
};

export type TestimonyInput = {
  name?: Maybe<Scalars['String']>;
  occupation?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
  companyName?: Maybe<Scalars['String']>;
  featured?: Maybe<Scalars['Boolean']>;
  aboutFeatured?: Maybe<Scalars['Boolean']>;
  testimony?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Testimony_Type>;
  clientCountry?: Maybe<Enum_Testimony_Clientcountry>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type TestimonyRelationResponseCollection = {
  __typename?: 'TestimonyRelationResponseCollection';
  nodes: Array<Testimony>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  documentId: Scalars['ID'];
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  focalPoint?: Maybe<Scalars['JSON']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  nodes: Array<UploadFile>;
  pageInfo: Pagination;
};

export type UploadFileFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  alternativeText?: Maybe<StringFilterInput>;
  caption?: Maybe<StringFilterInput>;
  focalPoint?: Maybe<JsonFilterInput>;
  width?: Maybe<IntFilterInput>;
  height?: Maybe<IntFilterInput>;
  formats?: Maybe<JsonFilterInput>;
  hash?: Maybe<StringFilterInput>;
  ext?: Maybe<StringFilterInput>;
  mime?: Maybe<StringFilterInput>;
  size?: Maybe<FloatFilterInput>;
  url?: Maybe<StringFilterInput>;
  previewUrl?: Maybe<StringFilterInput>;
  provider?: Maybe<StringFilterInput>;
  provider_metadata?: Maybe<JsonFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<UploadFileFiltersInput>>>;
  or?: Maybe<Array<Maybe<UploadFileFiltersInput>>>;
  not?: Maybe<UploadFileFiltersInput>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  nodes: Array<UploadFile>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Scalars['String'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  id: Scalars['ID'];
  documentId: Scalars['ID'];
  username: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsMeRole>;
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  documentId: Scalars['ID'];
  action: Scalars['String'];
  role?: Maybe<UsersPermissionsRole>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  action?: Maybe<StringFilterInput>;
  role?: Maybe<UsersPermissionsRoleFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<UsersPermissionsPermissionFiltersInput>>>;
  or?: Maybe<Array<Maybe<UsersPermissionsPermissionFiltersInput>>>;
  not?: Maybe<UsersPermissionsPermissionFiltersInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  nodes: Array<UsersPermissionsPermission>;
};

export type UsersPermissionsRegisterInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  documentId: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions_connection?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  permissions: Array<Maybe<UsersPermissionsPermission>>;
  users_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  users: Array<Maybe<UsersPermissionsUser>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type UsersPermissionsRolePermissions_ConnectionArgs = {
  filters?: Maybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: Maybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsRoleUsers_ConnectionArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  nodes: Array<UsersPermissionsRole>;
  pageInfo: Pagination;
};

export type UsersPermissionsRoleFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  description?: Maybe<StringFilterInput>;
  type?: Maybe<StringFilterInput>;
  permissions?: Maybe<UsersPermissionsPermissionFiltersInput>;
  users?: Maybe<UsersPermissionsUserFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<UsersPermissionsRoleFiltersInput>>>;
  or?: Maybe<Array<Maybe<UsersPermissionsRoleFiltersInput>>>;
  not?: Maybe<UsersPermissionsRoleFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  documentId: Scalars['ID'];
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsRole>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUser>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  nodes: Array<UsersPermissionsUser>;
  pageInfo: Pagination;
};

export type UsersPermissionsUserFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  username?: Maybe<StringFilterInput>;
  email?: Maybe<StringFilterInput>;
  provider?: Maybe<StringFilterInput>;
  confirmed?: Maybe<BooleanFilterInput>;
  blocked?: Maybe<BooleanFilterInput>;
  role?: Maybe<UsersPermissionsRoleFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<UsersPermissionsUserFiltersInput>>>;
  or?: Maybe<Array<Maybe<UsersPermissionsUserFiltersInput>>>;
  not?: Maybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsUserInput = {
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  password?: Maybe<Scalars['String']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  nodes: Array<UsersPermissionsUser>;
};

export type WebsiteContact = {
  __typename?: 'WebsiteContact';
  documentId: Scalars['ID'];
  name: Scalars['String'];
  email: Scalars['String'];
  message: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  formTitle?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  bufferPdf?: Maybe<Scalars['String']>;
  wizardId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type WebsiteContactEntityResponseCollection = {
  __typename?: 'WebsiteContactEntityResponseCollection';
  nodes: Array<WebsiteContact>;
  pageInfo: Pagination;
};

export type WebsiteContactFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  email?: Maybe<StringFilterInput>;
  message?: Maybe<StringFilterInput>;
  phone?: Maybe<StringFilterInput>;
  formTitle?: Maybe<StringFilterInput>;
  url?: Maybe<StringFilterInput>;
  bufferPdf?: Maybe<StringFilterInput>;
  wizardId?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<WebsiteContactFiltersInput>>>;
  or?: Maybe<Array<Maybe<WebsiteContactFiltersInput>>>;
  not?: Maybe<WebsiteContactFiltersInput>;
};

export type WebsiteContactInput = {
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  formTitle?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  bufferPdf?: Maybe<Scalars['String']>;
  wizardId?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type WizardSubmission = {
  __typename?: 'WizardSubmission';
  documentId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  successMessage?: Maybe<Scalars['String']>;
  descriptionSection?: Maybe<ComponentComponentsDescriptionSection>;
  formSection?: Maybe<Array<Maybe<ComponentComponentsFormSectionWithAnswers>>>;
  hash?: Maybe<Scalars['String']>;
  additionalInfo?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type WizardSubmissionFormSectionArgs = {
  filters?: Maybe<ComponentComponentsFormSectionWithAnswersFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WizardSubmissionEntityResponseCollection = {
  __typename?: 'WizardSubmissionEntityResponseCollection';
  nodes: Array<WizardSubmission>;
  pageInfo: Pagination;
};

export type WizardSubmissionFiltersInput = {
  documentId?: Maybe<IdFilterInput>;
  title?: Maybe<StringFilterInput>;
  slug?: Maybe<StringFilterInput>;
  successMessage?: Maybe<StringFilterInput>;
  descriptionSection?: Maybe<ComponentComponentsDescriptionSectionFiltersInput>;
  formSection?: Maybe<ComponentComponentsFormSectionWithAnswersFiltersInput>;
  hash?: Maybe<StringFilterInput>;
  additionalInfo?: Maybe<JsonFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<WizardSubmissionFiltersInput>>>;
  or?: Maybe<Array<Maybe<WizardSubmissionFiltersInput>>>;
  not?: Maybe<WizardSubmissionFiltersInput>;
};

export type WizardSubmissionInput = {
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  successMessage?: Maybe<Scalars['String']>;
  descriptionSection?: Maybe<ComponentComponentsDescriptionSectionInput>;
  formSection?: Maybe<Array<Maybe<ComponentComponentsFormSectionWithAnswersInput>>>;
  hash?: Maybe<Scalars['String']>;
  additionalInfo?: Maybe<Scalars['JSON']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};
